webpackJsonp([1],[
/* 0 */,
/* 1 */
/*!**************************!*\
  !*** ./src/libs/util.js ***!
  \**************************/
/*! exports provided: inert, toType, timestamp, fromMin, toMin, getJSON, putJSON, checkStatus, toJSON, StyleInline */
/*! exports used: StyleInline, fromMin, getJSON, inert, putJSON, timestamp, toMin, toType */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = inert;
/* harmony export (immutable) */ __webpack_exports__["h"] = toType;
/* harmony export (immutable) */ __webpack_exports__["f"] = timestamp;
/* harmony export (immutable) */ __webpack_exports__["b"] = fromMin;
/* harmony export (immutable) */ __webpack_exports__["g"] = toMin;
/* harmony export (immutable) */ __webpack_exports__["c"] = getJSON;
/* harmony export (immutable) */ __webpack_exports__["e"] = putJSON;
/* unused harmony export checkStatus */
/* unused harmony export toJSON */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyleInline; });
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function inert(x) {
  return JSON.parse(JSON.stringify(x));
}

function toType(o) {
  return !o || (typeof o === 'undefined' ? 'undefined' : _typeof(o)) !== 'object' ? typeof o === 'boolean' ? 'ValueString' : typeof o === 'number' ? 'ValueText' : 'ValueText' : Array.isArray(o) ? 'ValueArray' : o['@id'] && o['@id'].charAt(0) !== '_' ? 'ValueReference' : typeof o['@value'] !== 'undefined' ? 'ValueLiteral' : 'ValueObject';
}

/* Date helpers */

function timestamp() {
  return new Date().toJSON().slice(0, 19) + 'Z';
}

/* Namespace handling */

// [{prefix: 'schema:', url: 'http://schema.org/'}]
// const namespaces = [{prefix: 'http:', url: 'https:'}, {prefix: 'https:', url: 'http:'}]
var namespaces = [];

function fromMin(obj) {
  // Replace prefix by url in strings
  if (typeof obj === 'string') {
    if (obj.endsWith('#id')) {
      obj = obj.slice(0, -3);
    }
    for (var i = namespaces.length - 1; i >= 0; i--) {
      obj = obj.replace(namespaces[i].prefix, namespaces[i].url);
    }
  }

  // Recursive transformation for objects
  else if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object') {
      for (var prop in obj) {
        obj[prop] = fromMin(obj[prop]);
      }
    }

  return obj;
}

function toMin(obj) {
  // Replace prefix by url in strings
  if (typeof obj === 'string') {
    for (var i = 0; i < namespaces.length; i++) {
      obj = obj.replace(namespaces[i].url, namespaces[i].prefix);
    }
  }

  // Recursive transformation for objects
  else if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object') {
      for (var prop in obj) {
        obj[prop] = toMin(obj[prop]);
      }
    }

  return obj;
}

/* HTTP */

// Force https on every request
var httpsFix = window.location.protocol !== 'https:' ? function (u) {
  return u;
} : function (u) {
  return 'https' + u.slice(u.indexOf(':'));
};

function getJSON(url) {
  return window.fetch(httpsFix(url), {
    redirect: 'follow',
    headers: {
      'Authorization': 'Basic ' + btoa('visitor:'),
      Accept: 'application/json'
    }
  }).then(checkStatus).then(toJSON);
}

function putJSON(data) {
  return window.fetch(httpsFix(data['@id']), {
    method: 'put',
    body: JSON.stringify(data),
    redirect: 'follow',
    headers: _defineProperty({
      'Authorization': 'Basic ' + btoa('visitor:'),
      Accept: 'application/json'
    }, 'Authorization', 'insecure')
  }).then(toJSON);
}

function checkStatus(response) {
  if (response.status < 400) {
    return response;
  }
  var error = new Error(response.statusText);
  error.status = response.status;
  error.response = response;
  throw error;
}

function toJSON(response) {
  return response.json();
}

var StyleInline = {
  render: function render(h) {
    return h('style', this.$slots.default);
  }
};

/***/ }),
/* 2 */,
/* 3 */,
/* 4 */
/*!****************************************!*\
  !*** ./src/components/InputSubtle.vue ***!
  \****************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_opt_build_repo_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_InputSubtle_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/opt/build/repo/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./InputSubtle.vue */ 55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b26b0ab0_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_InputSubtle_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-b26b0ab0","hasScoped":false}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./InputSubtle.vue */ 56);
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_opt_build_repo_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_InputSubtle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b26b0ab0_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_InputSubtle_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 5 */
/*!****************************************!*\
  !*** ./src/components/ValueObject.vue ***!
  \****************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_opt_build_repo_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_ValueObject_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/opt/build/repo/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./ValueObject.vue */ 67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dffa81be_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ValueObject_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-dffa81be","hasScoped":false}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./ValueObject.vue */ 78);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-dffa81be","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ValueObject.vue */ 66)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_opt_build_repo_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_ValueObject_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dffa81be_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ValueObject_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 6 */,
/* 7 */
/*!***************************************!*\
  !*** ./src/components/InputClass.vue ***!
  \***************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_opt_build_repo_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_InputClass_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/opt/build/repo/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./InputClass.vue */ 48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d29cbcd_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_InputClass_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-0d29cbcd","hasScoped":false}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./InputClass.vue */ 50);
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_opt_build_repo_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_InputClass_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d29cbcd_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_InputClass_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 8 */
/*!*********************************!*\
  !*** ./src/components/Prop.vue ***!
  \*********************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_opt_build_repo_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_Prop_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/opt/build/repo/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./Prop.vue */ 58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fe3f3bc_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Prop_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-6fe3f3bc","hasScoped":false}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./Prop.vue */ 87);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-6fe3f3bc","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Prop.vue */ 57)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_opt_build_repo_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_Prop_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fe3f3bc_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Prop_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 9 */
/*!***************************************!*\
  !*** ./src/components/ValueArray.vue ***!
  \***************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_opt_build_repo_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_ValueArray_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/opt/build/repo/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./ValueArray.vue */ 60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5522332_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ValueArray_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-b5522332","hasScoped":false}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./ValueArray.vue */ 86);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-b5522332","scoped":false,"hasInlineConfig":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ValueArray.vue */ 59)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_opt_build_repo_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_ValueArray_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5522332_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ValueArray_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 10 */
/*!*****************************************!*\
  !*** ./src/components/ValueLiteral.vue ***!
  \*****************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_opt_build_repo_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_ValueLiteral_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/opt/build/repo/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./ValueLiteral.vue */ 61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26afdc3d_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ValueLiteral_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-26afdc3d","hasScoped":false}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./ValueLiteral.vue */ 65);
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_opt_build_repo_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_ValueLiteral_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26afdc3d_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ValueLiteral_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 11 */
/*!**************************************!*\
  !*** ./src/components/PropsList.vue ***!
  \**************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_opt_build_repo_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_PropsList_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/opt/build/repo/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./PropsList.vue */ 72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16dd787f_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_PropsList_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-16dd787f","hasScoped":false}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./PropsList.vue */ 77);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-16dd787f","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./PropsList.vue */ 71)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_opt_build_repo_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_PropsList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16dd787f_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_PropsList_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 12 */
/*!*******************************************!*\
  !*** ./src/components/ValueReference.vue ***!
  \*******************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_opt_build_repo_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_ValueReference_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/opt/build/repo/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./ValueReference.vue */ 80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1eb3f14e_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ValueReference_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-1eb3f14e","hasScoped":false}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./ValueReference.vue */ 81);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-1eb3f14e","scoped":false,"hasInlineConfig":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ValueReference.vue */ 79)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_opt_build_repo_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_ValueReference_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1eb3f14e_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ValueReference_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 13 */
/*!****************************************!*\
  !*** ./src/components/ValueString.vue ***!
  \****************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_opt_build_repo_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_ValueString_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/opt/build/repo/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./ValueString.vue */ 82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1aae7a1a_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ValueString_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-1aae7a1a","hasScoped":false}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./ValueString.vue */ 83);
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_opt_build_repo_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_ValueString_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1aae7a1a_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ValueString_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 14 */
/*!**************************************!*\
  !*** ./src/components/ValueText.vue ***!
  \**************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_opt_build_repo_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_ValueText_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/opt/build/repo/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./ValueText.vue */ 84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ebc136e2_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ValueText_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-ebc136e2","hasScoped":false}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./ValueText.vue */ 85);
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_opt_build_repo_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_ValueText_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ebc136e2_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ValueText_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */
/*!****************************************!*\
  !*** ./src/components/InputSingle.vue ***!
  \****************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_opt_build_repo_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_InputSingle_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/opt/build/repo/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./InputSingle.vue */ 93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b1b427a_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_InputSingle_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-3b1b427a","hasScoped":false}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./InputSingle.vue */ 94);
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_opt_build_repo_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_InputSingle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b1b427a_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_InputSingle_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 19 */
/*!****************************!*\
  !*** multi ./src/index.js ***!
  \****************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! /opt/build/repo/src/index.js */20);


/***/ }),
/* 20 */
/*!**********************!*\
  !*** ./src/index.js ***!
  \**********************/
/*! no exports provided */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue__ = __webpack_require__(/*! ./App.vue */ 22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scss_app_scss__ = __webpack_require__(/*! ./scss/app.scss */ 104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scss_app_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__scss_app_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Prop_vue__ = __webpack_require__(/*! ./components/Prop.vue */ 8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_RecentFragments_vue__ = __webpack_require__(/*! ./components/RecentFragments.vue */ 105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_InputSingle_vue__ = __webpack_require__(/*! ./components/InputSingle.vue */ 18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_Router_js__ = __webpack_require__(/*! ./mixins/Router.js */ 108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_Store_js__ = __webpack_require__(/*! ./mixins/Store.js */ 109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_User_js__ = __webpack_require__(/*! ./mixins/User.js */ 122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_Worker_js__ = __webpack_require__(/*! ./mixins/Worker.js */ 124);


// Pages



// Modals




// Must be available in plugins







// Fix recursive initializing bug: PropsList > Prop > ValueObject > PropsList > Prop > ...
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('Prop', __WEBPACK_IMPORTED_MODULE_3__components_Prop_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('RecentFragments', __WEBPACK_IMPORTED_MODULE_4__components_RecentFragments_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('InputSingle', __WEBPACK_IMPORTED_MODULE_5__components_InputSingle_vue__["a" /* default */]);

window.Vue = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */];
window.hub = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();
window.ld3 = true;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  methods: {
    extend: function extend(comp) {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend(comp);
    }
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_Router_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_Store_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__mixins_User_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__mixins_Worker_js__["a" /* default */]],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App_vue__["a" /* default */]);
  }
});

/***/ }),
/* 21 */,
/* 22 */
/*!*********************!*\
  !*** ./src/App.vue ***!
  \*********************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_opt_build_repo_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/opt/build/repo/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!../node_modules/vue-loader/lib/selector?type=script&index=0!./App.vue */ 23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_427a9fc7_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(/*! !../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-427a9fc7","hasScoped":false}!../node_modules/vue-loader/lib/selector?type=template&index=0!./App.vue */ 103);
var normalizeComponent = __webpack_require__(/*! ../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_opt_build_repo_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_427a9fc7_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 23 */
/*!************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/opt/build/repo/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue ***!
  \************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AppLeft_vue__ = __webpack_require__(/*! ./components/AppLeft.vue */ 24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AppNav_vue__ = __webpack_require__(/*! ./components/AppNav.vue */ 28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AppSync_vue__ = __webpack_require__(/*! ./components/AppSync.vue */ 32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Home_vue__ = __webpack_require__(/*! ./components/Home.vue */ 36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Conf_vue__ = __webpack_require__(/*! ./components/Conf.vue */ 39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Edit_vue__ = __webpack_require__(/*! ./components/Edit.vue */ 43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Create_vue__ = __webpack_require__(/*! ./components/Create.vue */ 97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ModalAuth_vue__ = __webpack_require__(/*! ./components/ModalAuth.vue */ 100);
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  computed: {
    appWide: function appWide() {
      return !this.$root.route || !this.$root.route.view || this.$root.route.view === 'home';
    }
  },
  components: {
    AppLeft: __WEBPACK_IMPORTED_MODULE_0__components_AppLeft_vue__["a" /* default */],
    AppNav: __WEBPACK_IMPORTED_MODULE_1__components_AppNav_vue__["a" /* default */],
    AppSync: __WEBPACK_IMPORTED_MODULE_2__components_AppSync_vue__["a" /* default */],
    Home: __WEBPACK_IMPORTED_MODULE_3__components_Home_vue__["a" /* default */],
    Conf: __WEBPACK_IMPORTED_MODULE_4__components_Conf_vue__["a" /* default */],
    Edit: __WEBPACK_IMPORTED_MODULE_5__components_Edit_vue__["a" /* default */],
    Create: __WEBPACK_IMPORTED_MODULE_6__components_Create_vue__["a" /* default */],
    ModalAuth: __WEBPACK_IMPORTED_MODULE_7__components_ModalAuth_vue__["a" /* default */]
  }
});

/***/ }),
/* 24 */
/*!************************************!*\
  !*** ./src/components/AppLeft.vue ***!
  \************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_opt_build_repo_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_AppLeft_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/opt/build/repo/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./AppLeft.vue */ 26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30a05559_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_AppLeft_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-30a05559","hasScoped":false}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./AppLeft.vue */ 27);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-30a05559","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./AppLeft.vue */ 25)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_opt_build_repo_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_AppLeft_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30a05559_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_AppLeft_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 25 */
/*!******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-30a05559","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/AppLeft.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 26 */
/*!***************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/opt/build/repo/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AppLeft.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    createByType: function createByType() {
      var id = '_:' + Math.random().toString(36).slice(2);
      this.$root.setFragment({
        '@type': null,
        '@id': id,
        'schema:name': null,
        'schema:description': null,
        'schema:url': null
      });
      window.location.hash = '!' + id;
    }
  }
});

/***/ }),
/* 27 */
/*!***********************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30a05559","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppLeft.vue ***!
  \***********************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-left",
    on: {
      "mouseenter": function($event) {
        _vm.$root.show.appLeft = _vm.$root.show.appLeft || 1
      }
    }
  }, [_c('a', {
    staticClass: "btn btn-soft",
    attrs: {
      "href": "#!create"
    },
    on: {
      "mouseenter": function($event) {
        _vm.$root.show.appLeft = 1
      }
    }
  }, [_vm._v("New")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-soft",
    attrs: {
      "href": "#!create"
    },
    on: {
      "mouseenter": function($event) {
        _vm.$root.show.appLeft = 2
      }
    }
  }, [_vm._v("Recent")]), _vm._v(" "), (_vm.$root.show.appLeft === 2) ? _c('div', {
    staticClass: "app-left-nested"
  }, [_c('nav', {
    staticClass: "nav-content"
  }, [_c('recent-fragments', {
    staticClass: "nav-fixwidth"
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.$root.show.appLeft === 1) ? _c('div', {
    staticClass: "app-left-nested"
  }, [_c('div', {
    staticClass: "app-left__btns"
  }, [_c('button', {
    staticClass: "btn-type fragment-type",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.createByType('Address')
      }
    }
  }, [_vm._v("Address")]), _vm._v(" "), _c('button', {
    staticClass: "btn-type fragment-type",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.createByType('Invoice')
      }
    }
  }, [_vm._v("Invoice")]), _vm._v(" "), _c('button', {
    staticClass: "btn-type fragment-type",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.createByType('LocalBusiness')
      }
    }
  }, [_vm._v("LocalBusiness")]), _vm._v(" "), _c('button', {
    staticClass: "btn-type fragment-type",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.createByType('Person')
      }
    }
  }, [_vm._v("Person")])])]) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 28 */
/*!***********************************!*\
  !*** ./src/components/AppNav.vue ***!
  \***********************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_opt_build_repo_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_AppNav_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/opt/build/repo/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./AppNav.vue */ 30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c0304c1_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_AppNav_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-3c0304c1","hasScoped":false}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./AppNav.vue */ 31);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-3c0304c1","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./AppNav.vue */ 29)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_opt_build_repo_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_AppNav_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c0304c1_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_AppNav_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 29 */
/*!*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3c0304c1","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/AppNav.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 30 */
/*!**************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/opt/build/repo/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AppNav.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      searchURI: null
    };
  },

  computed: {
    placeholder: function placeholder() {
      return this.$root.route && this.$root.route.uri || 'Search for data...';
    },

    search: {
      get: function get() {
        return this.$root.route && this.$root.route.uri || null;
      },
      set: function set(v) {
        this.searchURI = v;
        window.location.hash = '!' + v;
      }
    }
  },
  methods: {
    submit: function submit() {
      window.location.hash = '!' + this.search;
    }
  }
});

/***/ }),
/* 31 */
/*!**********************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c0304c1","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppNav.vue ***!
  \**********************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "app-nav",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "nav-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "app-nav__input",
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder,
      "autofocus": "",
      "autocomplete": "",
      "autosave": ""
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  })])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav-left"
  }, [_c('a', {
    staticClass: "btn btn-soft",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("ld3")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 32 */
/*!************************************!*\
  !*** ./src/components/AppSync.vue ***!
  \************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_opt_build_repo_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_AppSync_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/opt/build/repo/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./AppSync.vue */ 33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_367c65ed_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_AppSync_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-367c65ed","hasScoped":false}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./AppSync.vue */ 35);
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_opt_build_repo_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_AppSync_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_367c65ed_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_AppSync_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 33 */
/*!***************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/opt/build/repo/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AppSync.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_equals__ = __webpack_require__(/*! ../libs/equals */ 34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_util__ = __webpack_require__(/*! ../libs/util */ 1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app-sync',
  computed: {
    localDiffs: function localDiffs() {
      var _this = this;

      return Object.keys(this.$root.storedFragments).filter(function (id) {
        return !Object(__WEBPACK_IMPORTED_MODULE_0__libs_equals__["a" /* default */])(_this.$root.fragments[id], _this.$root.storedFragments[id]);
      });
    },
    fetchDiffs: function fetchDiffs() {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.$root.syncLocal();
      });
      return Object.keys(this.$root.fetchedFragments).filter(function (id) {
        return !Object(__WEBPACK_IMPORTED_MODULE_0__libs_equals__["a" /* default */])(_this2.$root.fragments[id], _this2.$root.fetchedFragments[id]);
      }).map(function (id) {
        return { id: id, diff: Object(__WEBPACK_IMPORTED_MODULE_0__libs_equals__["b" /* differs */])(_this2.$root.fetchedFragments[id], _this2.$root.fragments[id]) };
      });
    }
  },
  methods: {
    visit: function visit(uri) {
      window.location.hash = '!' + uri;
    },
    sync: function sync(uri) {
      this.$root.sync(uri);
    },
    discard: function discard(uri) {
      this.$root.discard(uri);
    }
  }
});

/***/ }),
/* 34 */
/*!****************************!*\
  !*** ./src/libs/equals.js ***!
  \****************************/
/*! exports provided: default, differs */
/*! exports used: default, differs */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = equals;
/* harmony export (immutable) */ __webpack_exports__["b"] = differs;
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

// Falsy values are ignored
function equals(x, y) {
  // Don't care about undefined, null, false, ''
  if (!x || !y) {
    return !x && !y;
  }
  if (x === y || x.valueOf() === y.valueOf()) {
    return true;
  }

  // Quick array check
  if (Array.isArray(x) && x.length !== y.length) {
    return false;
  }

  // Recursive check
  var xKeys = Object.keys(x);
  return (typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object' && (typeof y === 'undefined' ? 'undefined' : _typeof(y)) === 'object' && Object.keys(y).every(function (i) {
    return xKeys.includes(i) || !y[i];
  }) && xKeys.every(function (i) {
    return equals(x[i], y[i]);
  });
}

// Returns object containing key/values that need to be copied from y and applied to x
function differs(x, y) {
  // Don't care about undefined, null, false, ''
  if ((typeof x === 'undefined' ? 'undefined' : _typeof(x)) !== 'object' || (typeof y === 'undefined' ? 'undefined' : _typeof(y)) !== 'object' || !x || !y) {
    return {};
  }

  // 
  var diff = {};
  Object.keys(y).forEach(function (key) {
    if (!equals(x[key], y[key])) {
      diff[key] = y[key];
    }
  });
  return diff;
}

/***/ }),
/* 35 */
/*!***********************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-367c65ed","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppSync.vue ***!
  \***********************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "opacity"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fetchDiffs.length),
      expression: "fetchDiffs.length"
    }],
    staticClass: "section-content"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fetchDiffs.length),
      expression: "fetchDiffs.length"
    }]
  }, [_vm._v("\n      The following data is out of sync:\n      "), _vm._l((_vm.fetchDiffs), function(diff) {
    return _c('p', {
      on: {
        "click": function($event) {
          _vm.visit(diff.id)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "float": "right"
      }
    }, [(_vm.localDiffs.includes(diff.id)) ? _c('button', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.$root.syncLocal($event)
        }
      }
    }, [_vm._v("Local")]) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.sync(diff.id)
        }
      }
    }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.discard(diff.id)
        }
      }
    }, [_vm._v("Discard")])]), _vm._v("\n        " + _vm._s(diff.id) + "\n        "), _c('br'), _c('small', [_vm._v(_vm._s(Object.keys(diff.diff).join(', ')))])])
  })], 2)])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 36 */
/*!*********************************!*\
  !*** ./src/components/Home.vue ***!
  \*********************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_opt_build_repo_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/opt/build/repo/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./Home.vue */ 37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33658cc4_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-33658cc4","hasScoped":false}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./Home.vue */ 38);
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_opt_build_repo_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33658cc4_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 37 */
/*!************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/opt/build/repo/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Home.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home'
});

/***/ }),
/* 38 */
/*!********************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33658cc4","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue ***!
  \********************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section-content"
  }, [_c('p', [_vm._v("\n    Fill in the URI of the resource you want to create/edit.\n  ")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "btn",
    attrs: {
      "href": "#!create"
    }
  }, [_vm._v("Create resource...")])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 39 */
/*!*********************************!*\
  !*** ./src/components/Conf.vue ***!
  \*********************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_opt_build_repo_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_Conf_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/opt/build/repo/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./Conf.vue */ 40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3eab6d3a_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Conf_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-3eab6d3a","hasScoped":false}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./Conf.vue */ 42);
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_opt_build_repo_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_Conf_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3eab6d3a_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Conf_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 40 */
/*!************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/opt/build/repo/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Conf.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_browser_js__ = __webpack_require__(/*! ../libs/browser.js */ 41);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'config',
  data: function data() {
    return {
      browser: Object(__WEBPACK_IMPORTED_MODULE_0__libs_browser_js__["a" /* default */])(),
      usage: [{ key: 'calculating...' }],
      percent: 0
    };
  },

  computed: {
    memory: function memory() {
      return [{
        key: 'fragments',
        count: Object.keys(this.$root.fragments).length,
        size: JSON.stringify(this.$root.fragments).length
      }, {
        key: 'fetchedFragments',
        count: Object.keys(this.$root.fetchedFragments).length,
        size: JSON.stringify(this.$root.fetchedFragments).length
      }];
    }
  },
  methods: {
    recalculate: function recalculate() {
      var usage = [];
      for (var key in window.localStorage) {
        // Special cases
        usage.push({
          key: key,
          count: key === 'fragments' ? Object.keys(JSON.parse(window.localStorage.getItem(key))).length || '0' : '',
          size: window.localStorage[key].length
        });
      }
      usage.sort(function (a, b) {
        return b.size - a.size;
      });
      this.percent = parseFloat((usage.reduce(function (a, b) {
        return a + b['size'];
      }, 0) / 50000).toPrecision(2));
      this.usage = usage;
    },
    forceCache: function forceCache() {
      this.$root.syncLocal();
      this.recalculate();
    }
  },
  mounted: function mounted() {
    this.recalculate();
    var self = this;
    setTimeout(function () {
      self.recalculate();
    });
  }
});

/***/ }),
/* 41 */
/*!*****************************!*\
  !*** ./src/libs/browser.js ***!
  \*****************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * http://stackoverflow.com/questions/9847580/how-to-detect-safari-chrome-ie-firefox-and-opera-browser
 * Gets the browser name or returns an empty string if unknown.
 * This function also caches the result to provide for any
 * future calls this function has.
 *
 * @returns {string}
 */
var browser = function browser() {
  // Return cached result if avalible, else get result then cache it.
  if (browser.prototype._cachedResult) {
    return browser.prototype._cachedResult;
  }

  var isOpera = !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
  // Opera 8.0+ (UA detection to detect Blink/v8-powered Opera)
  var isFirefox = typeof InstallTrigger !== 'undefined'; // Firefox 1.0+
  var isSafari = Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0;
  // At least Safari 3+: "[object HTMLElementConstructor]"
  var isChrome = !!window.chrome && !isOpera; // Chrome 1+
  var isIE = /* @cc_on!@*/false || !!document.documentMode; // At least IE6

  return browser.prototype._cachedResult = isOpera ? 'Opera' : isFirefox ? 'Firefox' : isSafari ? 'Safari' : isChrome ? 'Chrome' : isIE ? 'IE' : '';
};

/* harmony default export */ __webpack_exports__["a"] = (browser);

/***/ }),
/* 42 */
/*!********************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3eab6d3a","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Conf.vue ***!
  \********************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section-content"
  }, [_c('h1', [_vm._v("conf")]), _vm._v(" "), _c('p', [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.forceCache
    }
  }, [_vm._v("Cache fragments")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$root.clearCache()
      }
    }
  }, [_vm._v("Clear cache")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$root.userLoad()
      }
    }
  }, [_vm._v("Load workspace")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$root.userLogout()
      }
    }
  }, [_vm._v("logout")])]), _vm._v(" "), _c('h2', [_vm._v("User")]), _vm._v(" "), _c('p', [_vm._v("\n    Logged in as " + _vm._s(JSON.stringify(_vm.$root.user['@id'])) + "\n  ")]), _vm._v(" "), _c('h2', [_vm._v("Namespaces")]), _vm._v(" "), _c('table', {
    staticClass: "tbl-conf",
    staticStyle: {
      "min-width": "300px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.$root.namespaces), function(ns) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(ns.prefix))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ns.url))])])
  }))]), _vm._v(" "), _c('h2', [_vm._v("Local Storage")]), _vm._v(" "), _c('p', [_vm._v("Volgende instellingen worden bewaard in " + _vm._s(_vm.browser) + ":")]), _vm._v(" "), _c('table', {
    staticClass: "tbl-conf",
    staticStyle: {
      "min-width": "300px"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_vm._l((_vm.usage), function(u) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(u.count))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(u.key))]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [_vm._v(_vm._s(u.size && u.size.toLocaleString()) + " b")])])
  }), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm.percent.toLocaleString()) + "% of 5 MB")])])], 2)]), _vm._v(" "), _c('h2', [_vm._v("Memory")]), _vm._v(" "), _c('table', {
    staticClass: "tbl-conf",
    staticStyle: {
      "min-width": "300px"
    }
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.memory), function(u) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(u.count))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(u.key))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(u.size && u.size.toLocaleString()) + " bytes")])])
  }))])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Namespace")]), _vm._v(" "), _c('th', [_vm._v("URL")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v("Item")]), _vm._v(" "), _c('th', [_vm._v("Size")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v("Item")]), _vm._v(" "), _c('th', [_vm._v("Size")])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 43 */
/*!*********************************!*\
  !*** ./src/components/Edit.vue ***!
  \*********************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_opt_build_repo_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/opt/build/repo/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./Edit.vue */ 44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62c52549_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-62c52549","hasScoped":false}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./Edit.vue */ 96);
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_opt_build_repo_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62c52549_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 44 */
/*!************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/opt/build/repo/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Edit.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_util_js__ = __webpack_require__(/*! ../libs/util.js */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Fragment_vue__ = __webpack_require__(/*! ./Fragment.vue */ 45);
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'edit',
  data: function data() {
    return {
      backdrop: false,
      focusIds: [],
      fragments: {}
    };
  },

  computed: {
    currentFragment: function currentFragment() {
      return this.$root.currentFragment;
    }
  },
  methods: {
    unfocus: function unfocus() {
      if (this.$root.listFocus.length > 1) {
        console.debug('edit keydown.esc unfocus');
        this.$root.listFocus.pop();
      }
    },
    keydown: function keydown(evt) {
      var key = evt.which || evt.keyCode;
      // esc
      if (key === 27) {
        this.unfocus();
      }
      // ctrl+s
      if ((evt.ctrlKey || evt.metaKey) && String.fromCharCode(evt.which).toLowerCase() === 's') {
        evt.preventDefault();
        if (this.$root.route && this.$root.route.uri) {
          this.$root.sync(this.currentFragment);
        }
      }
      // ctrl+s
      if (key === 114 || (evt.ctrlKey || evt.metaKey) && key === 70) {
        evt.preventDefault();
        document.querySelector('nav input').focus();
      }
    }
  },
  mounted: function mounted() {
    window.addEventListener('keydown', this.keydown, false);
    // console.info(window.location)
    // console.log('edit', this.$route.path)
  },
  destroyed: function destroyed() {
    window.removeEventListener('keydown', this.keydown, false);
  },

  components: {
    Fragment: __WEBPACK_IMPORTED_MODULE_1__Fragment_vue__["a" /* default */]
  }
});

/***/ }),
/* 45 */
/*!*************************************!*\
  !*** ./src/components/Fragment.vue ***!
  \*************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_opt_build_repo_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_Fragment_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/opt/build/repo/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./Fragment.vue */ 47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eb9449e2_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Fragment_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-eb9449e2","hasScoped":false}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./Fragment.vue */ 95);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-eb9449e2","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Fragment.vue */ 46)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_opt_build_repo_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_Fragment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eb9449e2_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Fragment_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 46 */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-eb9449e2","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Fragment.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 47 */
/*!****************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/opt/build/repo/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Fragment.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__InputClass_vue__ = __webpack_require__(/*! ./InputClass.vue */ 7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__InputRaw_vue__ = __webpack_require__(/*! ./InputRaw.vue */ 51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InputSubtle_vue__ = __webpack_require__(/*! ./InputSubtle.vue */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Prop_vue__ = __webpack_require__(/*! ./Prop.vue */ 8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PropsList_vue__ = __webpack_require__(/*! ./PropsList.vue */ 11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TextareaSubtle_vue__ = __webpack_require__(/*! ./TextareaSubtle.vue */ 88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_PluginSystem_js__ = __webpack_require__(/*! ../mixins/PluginSystem.js */ 91);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fragment',
  props: ['fragment'],
  data: function data() {
    return {
      options: {
        resolve: 0
      },
      copyURI: '',
      advanced: 0,
      addPropShow: false,
      addPropSearch: '',
      addPropValue: ''
    };
  },

  computed: {
    niceType: function niceType() {
      var t = this.fragment['@type'];
      return t ? t.slice(t.lastIndexOf(':') + 1) : '?';
    },
    props: function props() {
      return this.fragment;
    },
    resolved: function resolved() {
      return this.$root.resolve(this.fragment, this.options.resolve);
    },
    focusProp: function focusProp() {
      // TODO: fill in route as first item in listFocus
      return this.$root.listFocus.length === 1;
    },
    focusFrom: function focusFrom() {
      return this.$root.listFocus.length > 1;
    }
  },
  methods: {
    copy: function copy(evt) {
      if (!this.copyURI) {
        return console.warn('Fragment: copyURI is empty');
      }
      this.$root.copyFragment(this.fragment['@id'], this.copyURI);
    }
  },
  watch: {
    advanced: function advanced() {
      this.copyURI = this.fragment['@id'];
    },
    '$root.route.uri': function $rootRouteUri(val) {
      this.$root.listFocus = [val];
    }
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_PluginSystem_js__["a" /* default */]],
  components: {
    InputClass: __WEBPACK_IMPORTED_MODULE_0__InputClass_vue__["a" /* default */],
    InputRaw: __WEBPACK_IMPORTED_MODULE_1__InputRaw_vue__["a" /* default */],
    InputSubtle: __WEBPACK_IMPORTED_MODULE_2__InputSubtle_vue__["a" /* default */],
    Prop: __WEBPACK_IMPORTED_MODULE_3__Prop_vue__["a" /* default */],
    PropsList: __WEBPACK_IMPORTED_MODULE_4__PropsList_vue__["a" /* default */],
    TextareaSubtle: __WEBPACK_IMPORTED_MODULE_5__TextareaSubtle_vue__["a" /* default */]
  }
});

/***/ }),
/* 48 */
/*!******************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/opt/build/repo/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/InputClass.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fuse_js__ = __webpack_require__(/*! fuse.js */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fuse_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fuse_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_schema_js__ = __webpack_require__(/*! ../libs/schema.js */ 49);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var fuseOptions = {
  caseSensitive: false,
  includeScore: true,
  shouldSort: true,
  tokenize: false,
  threshold: 0.6,
  location: 0,
  distance: 100,
  id: 'i',
  keys: ['i']
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'input-class',
  props: ['value', 'placeholder'],
  data: function data() {
    return {
      term: null,
      options: null,
      ghost: 0
    };
  },

  computed: {
    index: function index() {
      return new __WEBPACK_IMPORTED_MODULE_0_fuse_js___default.a(__WEBPACK_IMPORTED_MODULE_1__libs_schema_js__["a" /* Classes */], fuseOptions);
    },
    related: function related() {
      if (!this.value) {
        return;
      }
      var value = this.value.slice(this.value.lastIndexOf(':') + 1);
      // Get parent classes
      var par = __WEBPACK_IMPORTED_MODULE_1__libs_schema_js__["a" /* Classes */].find(function (c) {
        return c.i === value;
      });
      var opts = par && par.s && (par.s.length ? par.s : [par.s]) || [];
      // Get child classes
      var chi = __WEBPACK_IMPORTED_MODULE_1__libs_schema_js__["a" /* Classes */].filter(function (c) {
        return c.s && (c.s.i === value || c.s.length && c.s.find(function (x) {
          return x.i === value;
        }));
      });
      opts = opts.concat(chi);
      // Transform to match options
      return opts.map(function (c) {
        return { item: c.i, score: '' };
      });
    },
    text: function text() {
      var t = this.value || this.placeholder;
      return t ? t.slice(t.lastIndexOf(':') + 1) : '?';
    }
  },
  methods: {
    blur: function blur() {
      var self = this;
      setTimeout(function () {
        self.term = null;
        self.ghost = 0;
        self.options = null;
      }, 100);
    },
    input: function input() {
      if (!this.term) {
        if (this.value) {
          this.options = this.related;
        } else {
          this.options = null;
          this.ghost = 0;
        }
        return;
      }
      this.options = this.index.search(this.term).slice(0, 20).concat({
        item: this.term,
        score: ''
      });
      this.changeGhost(0);
    },
    keydown: function keydown(evt) {
      var key = evt.which || evt.keyCode;
      if (key === 9 && !(this.term === null && this.ghost === 0)) {
        // tab: submit if touched anything
        this.submit();
      } else if (key === 13) {
        // enter: form will submit, but should also blur
        this.blur();
      } else if (key === 38) {
        // arrow up
        this.changeGhost(-1);
      } else if (key === 40) {
        // arrow down
        this.changeGhost(1);
      }
    },
    changeGhost: function changeGhost(i) {
      this.ghost = Math.max(Math.min(this.ghost + i, (this.options.length || 1) - 1), 0);
    },
    submit: function submit(evt) {
      this.confirm(this.options && this.options[this.ghost] && this.options[this.ghost].item || 'Thing');
      return false;
    },
    confirm: function confirm(uri) {
      if (typeof uri !== 'string' || !uri) {
        return console.warn('confirming but dont know what', uri);
      }
      this.term = null;
      this.ghost = 0;
      this.$emit('input', 'schema:' + uri);
    }
  }
});

/***/ }),
/* 49 */
/*!****************************!*\
  !*** ./src/libs/schema.js ***!
  \****************************/
/*! exports provided: Properties, Classes */
/*! exports used: Classes */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Properties */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Classes; });
/* eslint-disable */

var Properties = ['about', 'acceptedAnswer', 'acceptedOffer', 'acceptedPaymentMethod', 'acceptsReservations', 'accessCode', 'accessibilityAPI', 'accessibilityControl', 'accessibilityFeature', 'accessibilityHazard', 'accountId', 'accountablePerson', 'acquiredFrom', 'action', 'actionApplication', 'actionOption', 'actionPlatform', 'actionStatus', 'activeIngredient', 'activityDuration', 'activityFrequency', 'actor', 'actors', 'addOn', 'additionalName', 'additionalNumberOfGuests', 'additionalProperty', 'additionalType', 'additionalVariable', 'address', 'addressCountry', 'addressLocality', 'addressRegion', 'administrationRoute', 'advanceBookingRequirement', 'adverseOutcome', 'affectedBy', 'affiliation', 'agent', 'aggregateRating', 'aircraft', 'album', 'albumProductionType', 'albumRelease', 'albumReleaseType', 'albums', 'alcoholWarning', 'algorithm', 'alignmentType', 'alternateName', 'alternativeHeadline', 'alumni', 'alumniOf', 'amount', 'amountOfThisGood', 'answerCount', 'antagonist', 'applicableLocation', 'application', 'applicationCategory', 'applicationSubCategory', 'applicationSuite', 'appliesToDeliveryMethod', 'appliesToPaymentMethod', 'area', 'areaServed', 'arrivalAirport', 'arrivalBusStop', 'arrivalGate', 'arrivalPlatform', 'arrivalStation', 'arrivalTerminal', 'arrivalTime', 'artEdition', 'artMedium', 'arterialBranch', 'artform', 'articleBody', 'articleSection', 'artworkSurface', 'aspect', 'assembly', 'assemblyVersion', 'associatedAnatomy', 'associatedArticle', 'associatedMedia', 'associatedPathophysiology', 'athlete', 'attendee', 'attendees', 'audience', 'audienceType', 'audio', 'author', 'availability', 'availabilityEnds', 'availabilityStarts', 'availableAtOrFrom', 'availableChannel', 'availableDeliveryMethod', 'availableFrom', 'availableIn', 'availableLanguage', 'availableOnDevice', 'availableService', 'availableStrength', 'availableTest', 'availableThrough', 'award', 'awards', 'awayTeam', 'background', 'baseSalary', 'benefits', 'bestRating', 'billingAddress', 'billingIncrement', 'billingPeriod', 'biomechnicalClass', 'birthDate', 'birthPlace', 'bitrate', 'blogPost', 'blogPosts', 'bloodSupply', 'boardingGroup', 'boardingPolicy', 'bodyLocation', 'bookEdition', 'bookFormat', 'bookingAgent', 'bookingTime', 'borrower', 'box', 'branch', 'branchCode', 'branchOf', 'brand', 'breadcrumb', 'breastfeedingWarning', 'broadcastAffiliateOf', 'broadcastChannelId', 'broadcastDisplayName', 'broadcastOfEvent', 'broadcastServiceTier', 'broadcastTimezone', 'broadcaster', 'broker', 'browserRequirements', 'busName', 'busNumber', 'businessFunction', 'buyer', 'byArtist', 'calories', 'candidate', 'caption', 'carbohydrateContent', 'cargoVolume', 'carrier', 'carrierRequirements', 'catalog', 'catalogNumber', 'category', 'cause', 'causeOf', 'character', 'characterAttribute', 'characterName', 'cheatCode', 'checkinTime', 'checkoutTime', 'childMaxAge', 'childMinAge', 'children', 'cholesterolContent', 'circle', 'citation', 'clincalPharmacology', 'clinicalPharmacology', 'clipNumber', 'closes', 'coach', 'code', 'codeRepository', 'codeSampleType', 'codeValue', 'codingSystem', 'colleague', 'colleagues', 'collection', 'color', 'comment', 'commentCount', 'commentText', 'commentTime', 'competitor', 'composer', 'comprisedOf', 'confirmationNumber', 'connectedTo', 'contactOption', 'contactPoint', 'contactPoints', 'contactType', 'containedIn', 'containedInPlace', 'containsPlace', 'containsSeason', 'contentLocation', 'contentRating', 'contentSize', 'contentType', 'contentUrl', 'contraindication', 'contributor', 'cookTime', 'cookingMethod', 'copyrightHolder', 'copyrightYear', 'cost', 'costCategory', 'costCurrency', 'costOrigin', 'costPerUnit', 'countriesNotSupported', 'countriesSupported', 'countryOfOrigin', 'course', 'coverageEndTime', 'coverageStartTime', 'creator', 'creditedTo', 'currenciesAccepted', 'currency', 'customer', 'dataFeedElement', 'dataset', 'datasetTimeInterval', 'dateCreated', 'dateDeleted', 'dateIssued', 'dateModified', 'datePosted', 'datePublished', 'dateVehicleFirstRegistered', 'dateline', 'dayOfWeek', 'deathDate', 'deathPlace', 'defaultValue', 'deliveryAddress', 'deliveryLeadTime', 'deliveryMethod', 'deliveryStatus', 'department', 'departureAirport', 'departureBusStop', 'departureGate', 'departurePlatform', 'departureStation', 'departureTerminal', 'departureTime', 'dependencies', 'depth', 'description', 'device', 'diagnosis', 'diagram', 'diet', 'dietFeatures', 'differentialDiagnosis', 'director', 'directors', 'discount', 'discountCode', 'discountCurrency', 'discusses', 'discussionUrl', 'dissolutionDate', 'distance', 'distinguishingSign', 'distribution', 'domainIncludes', 'doorTime', 'dosageForm', 'doseSchedule', 'doseUnit', 'doseValue', 'downloadUrl', 'downvoteCount', 'drainsTo', 'driveWheelConfiguration', 'dropoffLocation', 'dropoffTime', 'drug', 'drugClass', 'drugUnit', 'duns', 'duplicateTherapy', 'duration', 'durationOfWarranty', 'editor', 'educationRequirements', 'educationalAlignment', 'educationalFramework', 'educationalRole', 'educationalUse', 'elevation', 'eligibleCustomerType', 'eligibleDuration', 'eligibleQuantity', 'eligibleRegion', 'eligibleTransactionVolume', 'email', 'embedUrl', 'employee', 'employees', 'employmentType', 'encodesCreativeWork', 'encoding', 'encodingFormat', 'encodingType', 'encodings', 'endDate', 'endTime', 'endorsee', 'endorsers', 'entertainmentBusiness', 'epidemiology', 'episode', 'episodeNumber', 'episodes', 'equal', 'error', 'estimatedFlightDuration', 'estimatesRiskOf', 'event', 'eventStatus', 'events', 'evidenceLevel', 'evidenceOrigin', 'exampleOfWork', 'executableLibraryName', 'exerciseCourse', 'exercisePlan', 'exerciseRelatedDiet', 'exerciseType', 'exifData', 'expectedArrivalFrom', 'expectedArrivalUntil', 'expectedPrognosis', 'expectsAcceptanceOf', 'experienceRequirements', 'expertConsiderations', 'expires', 'familyName', 'fatContent', 'faxNumber', 'featureList', 'fiberContent', 'fileFormat', 'fileSize', 'firstPerformance', 'flightDistance', 'flightNumber', 'followee', 'follows', 'followup', 'foodEstablishment', 'foodEvent', 'foodWarning', 'founder', 'founders', 'foundingDate', 'foundingLocation', 'free', 'frequency', 'fromLocation', 'fuelConsumption', 'fuelEfficiency', 'fuelType', 'function', 'functionalClass', 'game', 'gameItem', 'gameLocation', 'gamePlatform', 'gameServer', 'gameTip', 'gender', 'genre', 'geo', 'geoMidpoint', 'geoRadius', 'geographicArea', 'givenName', 'globalLocationNumber', 'greater', 'greaterOrEqual', 'gtin12', 'gtin13', 'gtin14', 'gtin8', 'guideline', 'guidelineDate', 'guidelineSubject', 'hasDeliveryMethod', 'hasMap', 'hasOfferCatalog', 'hasPOS', 'hasPart', 'headline', 'healthCondition', 'height', 'highPrice', 'hiringOrganization', 'homeLocation', 'homeTeam', 'honorificPrefix', 'honorificSuffix', 'hospitalAffiliation', 'hostingOrganization', 'hoursAvailable', 'howPerformed', 'httpMethod', 'iataCode', 'icaoCode', 'identifyingExam', 'identifyingTest', 'illustrator', 'image', 'imagingTechnique', 'inAlbum', 'inBroadcastLineup', 'inLanguage', 'inPlaylist', 'incentiveCompensation', 'incentives', 'includedComposition', 'includedDataCatalog', 'includedRiskFactor', 'includesObject', 'increasesRiskOf', 'indication', 'industry', 'ineligibleRegion', 'infectiousAgent', 'infectiousAgentClass', 'ingredients', 'insertion', 'installUrl', 'instrument', 'intensity', 'interactingDrug', 'interactionCount', 'interactionService', 'interactionStatistic', 'interactionType', 'interactivityType', 'inventoryLevel', 'inverseOf', 'isAccessibleForFree', 'isAccessoryOrSparePartFor', 'isAvailableGenerically', 'isBasedOnUrl', 'isConsumableFor', 'isFamilyFriendly', 'isGift', 'isLiveBroadcast', 'isPartOf', 'isProprietary', 'isRelatedTo', 'isSimilarTo', 'isVariantOf', 'isbn', 'isicV4', 'isrcCode', 'issn', 'issueNumber', 'issuedBy', 'issuedThrough', 'iswcCode', 'item', 'itemCondition', 'itemListElement', 'itemListOrder', 'itemOffered', 'itemReviewed', 'itemShipped', 'jobBenefits', 'jobLocation', 'jobTitle', 'keywords', 'knownVehicleDamages', 'knows', 'labelDetails', 'landlord', 'language', 'lastReviewed', 'latitude', 'learningResourceType', 'legalName', 'legalStatus', 'lender', 'lesser', 'lesserOrEqual', 'license', 'line', 'liveBlogUpdate', 'location', 'locationCreated', 'lodgingUnitDescription', 'lodgingUnitType', 'logo', 'longitude', 'loser', 'lowPrice', 'lyricist', 'lyrics', 'mainContentOfPage', 'mainEntity', 'mainEntityOfPage', 'makesOffer', 'manufacturer', 'map', 'mapType', 'maps', 'material', 'maxPrice', 'maxValue', 'maximumIntake', 'mealService', 'mechanismOfAction', 'medicalSpecialty', 'medicineSystem', 'member', 'memberOf', 'members', 'membershipNumber', 'memoryRequirements', 'mentions', 'menu', 'merchant', 'mileageFromOdometer', 'minPrice', 'minValue', 'minimumPaymentDue', 'model', 'modifiedTime', 'mpn', 'multipleValues', 'muscleAction', 'musicArrangement', 'musicBy', 'musicCompositionForm', 'musicGroupMember', 'musicReleaseFormat', 'musicalKey', 'naics', 'name', 'namedPosition', 'nationality', 'naturalProgression', 'nerve', 'nerveMotor', 'netWorth', 'nextItem', 'nonEqual', 'nonProprietaryName', 'normalRange', 'numAdults', 'numChildren', 'numTracks', 'numberOfAirbags', 'numberOfAxles', 'numberOfDoors', 'numberOfEmployees', 'numberOfEpisodes', 'numberOfForwardGears', 'numberOfItems', 'numberOfPages', 'numberOfPlayers', 'numberOfPreviousOwners', 'numberOfSeasons', 'numberedPosition', 'nutrition', 'object', 'occupationalCategory', 'offerCount', 'offeredBy', 'offers', 'openingHours', 'openingHoursSpecification', 'opens', 'operatingSystem', 'opponent', 'option', 'orderDate', 'orderDelivery', 'orderItemNumber', 'orderItemStatus', 'orderNumber', 'orderQuantity', 'orderStatus', 'orderedItem', 'organizer', 'origin', 'originAddress', 'originatesFrom', 'outcome', 'overdosage', 'overview', 'ownedFrom', 'ownedThrough', 'owns', 'pageEnd', 'pageStart', 'pagination', 'parent', 'parentItem', 'parentOrganization', 'parentService', 'parents', 'partOfEpisode', 'partOfInvoice', 'partOfOrder', 'partOfSeason', 'partOfSeries', 'partOfSystem', 'partOfTVSeries', 'participant', 'partySize', 'passengerPriorityStatus', 'passengerSequenceNumber', 'pathophysiology', 'paymentAccepted', 'paymentDue', 'paymentDueDate', 'paymentMethod', 'paymentMethodId', 'paymentStatus', 'paymentUrl', 'performer', 'performerIn', 'performers', 'permissions', 'permitAudience', 'phase', 'photo', 'photos', 'physiologicalBenefits', 'pickupLocation', 'pickupTime', 'playMode', 'playerType', 'playersOnline', 'polygon', 'population', 'position', 'possibleComplication', 'possibleTreatment', 'postOfficeBoxNumber', 'postOp', 'postalCode', 'potentialAction', 'preOp', 'predecessorOf', 'pregnancyCategory', 'pregnancyWarning', 'prepTime', 'preparation', 'prescribingInfo', 'prescriptionStatus', 'previousItem', 'previousStartDate', 'price', 'priceCurrency', 'priceRange', 'priceSpecification', 'priceType', 'priceValidUntil', 'primaryImageOfPage', 'primaryPrevention', 'printColumn', 'printEdition', 'printPage', 'printSection', 'procedure', 'procedureType', 'processingTime', 'processorRequirements', 'producer', 'produces', 'productID', 'productSupported', 'productionCompany', 'productionDate', 'proficiencyLevel', 'programMembershipUsed', 'programName', 'programmingLanguage', 'programmingModel', 'propertyID', 'proprietaryName', 'proteinContent', 'provider', 'providerMobility', 'providesBroadcastService', 'providesService', 'publication', 'publicationType', 'publishedOn', 'publisher', 'publishingPrinciples', 'purchaseDate', 'purpose', 'qualifications', 'query', 'quest', 'question', 'rangeIncludes', 'ratingCount', 'ratingValue', 'readonlyValue', 'realEstateAgent', 'recipe', 'recipeCategory', 'recipeCuisine', 'recipeIngredient', 'recipeInstructions', 'recipeYield', 'recipient', 'recognizingAuthority', 'recommendationStrength', 'recommendedIntake', 'recordLabel', 'recordedAs', 'recordedAt', 'recordedIn', 'recordingOf', 'referencesOrder', 'regionDrained', 'regionsAllowed', 'relatedAnatomy', 'relatedCondition', 'relatedDrug', 'relatedLink', 'relatedStructure', 'relatedTherapy', 'relatedTo', 'releaseDate', 'releaseNotes', 'releaseOf', 'releasedEvent', 'relevantSpecialty', 'repetitions', 'replacee', 'replacer', 'replyToUrl', 'reportNumber', 'representativeOfPage', 'requiredGender', 'requiredMaxAge', 'requiredMinAge', 'requirements', 'requiresSubscription', 'reservationFor', 'reservationId', 'reservationStatus', 'reservedTicket', 'responsibilities', 'restPeriods', 'result', 'resultComment', 'resultReview', 'review', 'reviewBody', 'reviewCount', 'reviewRating', 'reviewedBy', 'reviews', 'riskFactor', 'risks', 'roleName', 'rsvpResponse', 'runsTo', 'runtime', 'runtimePlatform', 'safetyConsideration', 'salaryCurrency', 'sameAs', 'sampleType', 'saturatedFatContent', 'scheduledPaymentDate', 'scheduledTime', 'schemaVersion', 'screenCount', 'screenshot', 'season', 'seasonNumber', 'seasons', 'seatNumber', 'seatRow', 'seatSection', 'seatingType', 'secondaryPrevention', 'securityScreening', 'seeks', 'seller', 'sender', 'sensoryUnit', 'serialNumber', 'seriousAdverseOutcome', 'serverStatus', 'servesCuisine', 'serviceArea', 'serviceAudience', 'serviceLocation', 'serviceOperator', 'serviceOutput', 'servicePhone', 'servicePostalAddress', 'serviceSmsNumber', 'serviceType', 'serviceUrl', 'servingSize', 'sharedContent', 'sibling', 'siblings', 'signDetected', 'signOrSymptom', 'significance', 'significantLink', 'significantLinks', 'skills', 'sku', 'sodiumContent', 'softwareAddOn', 'softwareHelp', 'softwareRequirements', 'softwareVersion', 'source', 'sourceOrganization', 'sourcedFrom', 'spatial', 'specialCommitments', 'specialty', 'sponsor', 'sport', 'sportsActivityLocation', 'sportsEvent', 'sportsTeam', 'spouse', 'stage', 'stageAsNumber', 'startDate', 'startTime', 'status', 'steeringPosition', 'stepValue', 'storageRequirements', 'streetAddress', 'strengthUnit', 'strengthValue', 'structuralClass', 'study', 'studyDesign', 'studyLocation', 'studySubject', 'subEvent', 'subEvents', 'subOrganization', 'subReservation', 'subStageSuffix', 'subStructure', 'subTest', 'subtitleLanguage', 'subtype', 'successorOf', 'sugarContent', 'suggestedAnswer', 'suggestedGender', 'suggestedMaxAge', 'suggestedMinAge', 'superEvent', 'supersededBy', 'supplyTo', 'supportingData', 'surface', 'target', 'targetCollection', 'targetDescription', 'targetName', 'targetPlatform', 'targetPopulation', 'targetProduct', 'targetUrl', 'taxID', 'telephone', 'temporal', 'text', 'thumbnail', 'thumbnailUrl', 'tickerSymbol', 'ticketNumber', 'ticketToken', 'ticketedSeat', 'timeRequired', 'tissueSample', 'title', 'toLocation', 'totalPaymentDue', 'totalPrice', 'totalTime', 'track', 'trackingNumber', 'trackingUrl', 'tracks', 'trailer', 'trainName', 'trainNumber', 'transFatContent', 'transcript', 'translator', 'transmissionMethod', 'trialDesign', 'tributary', 'typeOfGood', 'typicalAgeRange', 'typicalTest', 'underName', 'unitCode', 'unitText', 'unsaturatedFatContent', 'uploadDate', 'upvoteCount', 'url', 'urlTemplate', 'usedToDiagnose', 'userInteractionCount', 'usesDevice', 'validFor', 'validFrom', 'validIn', 'validThrough', 'validUntil', 'value', 'valueAddedTaxIncluded', 'valueMaxLength', 'valueMinLength', 'valueName', 'valuePattern', 'valueReference', 'valueRequired', 'vatID', 'vehicleConfiguration', 'vehicleEngine', 'vehicleIdentificationNumber', 'vehicleInteriorColor', 'vehicleInteriorType', 'vehicleModelDate', 'vehicleSeatingCapacity', 'vehicleSpecialUsage', 'vehicleTransmission', 'vendor', 'version', 'video', 'videoFormat', 'videoFrameSize', 'videoQuality', 'volumeNumber', 'warning', 'warranty', 'warrantyPromise', 'warrantyScope', 'webCheckinTime', 'weight', 'width', 'winner', 'wordCount', 'workExample', 'workFeatured', 'workHours', 'workLocation', 'workPerformed', 'workPresented', 'workload', 'worksFor', 'worstRating', 'yearlyRevenue', 'yearsInOperation'];

// i => @id
// s => subClassOf
var Classes = [{ i: "APIReference", s: { i: 'TechArticle' } }, { i: 'AboutPage', s: { i: 'WebPage' } }, { i: 'AcceptAction', s: { i: 'AllocateAction' } }, { i: 'AccountingService', s: { i: 'FinancialService' } }, { i: 'AchieveAction', s: { i: 'Action' } }, { i: 'Action', s: { i: 'Thing' } }, { i: 'ActionStatusType', s: { i: 'Enumeration' } }, { i: 'ActivateAction', s: { i: 'ControlAction' } }, { i: 'AddAction', s: { i: 'UpdateAction' } }, { i: 'AdministrativeArea', s: { i: 'Place' } }, { i: 'AdultEntertainment', s: { i: 'EntertainmentBusiness' } }, { i: 'AggregateOffer', s: { i: 'Offer' } }, { i: 'AggregateRating', s: { i: 'Rating' } }, { i: 'AgreeAction', s: { i: 'ReactAction' } }, { i: 'Airline', s: { i: 'Organization' } }, { i: 'Airport', s: { i: 'CivicStructure' } }, { i: 'AlignmentObject', s: { i: 'Intangible' } }, { i: 'AllocateAction', s: { i: 'OrganizeAction' } }, { i: 'AmusementPark', s: { i: 'EntertainmentBusiness' } }, { i: 'AnatomicalStructure', s: { i: 'MedicalEntity' } }, { i: 'AnatomicalSystem', s: { i: 'MedicalEntity' } }, { i: 'AnimalShelter', s: { i: 'LocalBusiness' } }, { i: 'Answer', s: { i: 'Comment' } }, { i: 'ApartmentComplex', s: { i: 'Residence' } }, { i: 'AppendAction', s: { i: 'InsertAction' } }, { i: 'ApplyAction', s: { i: 'OrganizeAction' } }, { i: 'ApprovedIndication', s: { i: 'MedicalIndication' } }, { i: 'Aquarium', s: { i: 'CivicStructure' } }, { i: 'ArriveAction', s: { i: 'MoveAction' } }, { i: 'ArtGallery', s: { i: 'EntertainmentBusiness' } }, { i: 'Artery', s: { i: 'Vessel' } }, { i: 'Article', s: { i: 'CreativeWork' } }, { i: 'AskAction', s: { i: 'CommunicateAction' } }, { i: 'AssessAction', s: { i: 'Action' } }, { i: 'AssignAction', s: { i: 'AllocateAction' } }, { i: 'Attorney', s: { i: 'LegalService' } }, { i: 'Audience', s: { i: 'Intangible' } }, { i: 'AudioObject', s: { i: 'MediaObject' } }, { i: 'AuthorizeAction', s: { i: 'AllocateAction' } }, { i: 'AutoBodyShop', s: { i: 'AutomotiveBusiness' } }, { i: 'AutoDealer', s: { i: 'AutomotiveBusiness' } }, { i: 'AutoPartsStore', s: [{ i: 'AutomotiveBusiness' }, { i: 'Store' }] }, { i: 'AutoRental', s: { i: 'AutomotiveBusiness' } }, { i: 'AutoRepair', s: { i: 'AutomotiveBusiness' } }, { i: 'AutoWash', s: { i: 'AutomotiveBusiness' } }, { i: 'AutomatedTeller', s: { i: 'FinancialService' } }, { i: 'AutomotiveBusiness', s: { i: 'LocalBusiness' } }, { i: 'Bakery', s: { i: 'FoodEstablishment' } }, { i: 'BankOrCreditUnion', s: { i: 'FinancialService' } }, { i: 'BarOrPub', s: { i: 'FoodEstablishment' } }, { i: 'Barcode', s: { i: 'ImageObject' } }, { i: 'Beach', s: { i: 'CivicStructure' } }, { i: 'BeautySalon', s: { i: 'HealthAndBeautyBusiness' } }, { i: 'BedAndBreakfast', s: { i: 'LodgingBusiness' } }, { i: 'BefriendAction', s: { i: 'InteractAction' } }, { i: 'BikeStore', s: { i: 'Store' } }, { i: 'Blog', s: { i: 'CreativeWork' } }, { i: 'BlogPosting', s: { i: 'SocialMediaPosting' } }, { i: 'BloodTest', s: { i: 'MedicalTest' } }, { i: 'BoardingPolicyType', s: { i: 'Enumeration' } }, { i: 'BodyOfWater', s: { i: 'Landform' } }, { i: 'Bone', s: { i: 'AnatomicalStructure' } }, { i: 'Book', s: { i: 'CreativeWork' } }, { i: 'BookFormatType', s: { i: 'Enumeration' } }, { i: 'BookSeries', s: { i: 'CreativeWorkSeries' } }, { i: 'BookStore', s: { i: 'Store' } }, { i: 'BookmarkAction', s: { i: 'OrganizeAction' } }, { i: 'BorrowAction', s: { i: 'TransferAction' } }, { i: 'BowlingAlley', s: { i: 'SportsActivityLocation' } }, { i: 'BrainStructure', s: { i: 'AnatomicalStructure' } }, { i: 'Brand', s: { i: 'Intangible' } }, { i: 'BreadcrumbList', s: { i: 'ItemList' } }, { i: 'Brewery', s: { i: 'FoodEstablishment' } }, { i: 'Bridge', s: { i: 'CivicStructure' } }, { i: 'BroadcastChannel', s: { i: 'Intangible' } }, { i: 'BroadcastEvent', s: { i: 'PublicationEvent' } }, { i: 'BroadcastService', s: { i: 'Service' } }, { i: 'BuddhistTemple', s: { i: 'PlaceOfWorship' } }, { i: 'BusReservation', s: { i: 'Reservation' } }, { i: 'BusStation', s: { i: 'CivicStructure' } }, { i: 'BusStop', s: { i: 'CivicStructure' } }, { i: 'BusTrip', s: { i: 'Intangible' } }, { i: 'BusinessAudience', s: { i: 'Audience' } }, { i: 'BusinessEntityType', s: { i: 'Enumeration' } }, { i: 'BusinessEvent', s: { i: 'Event' } }, { i: 'BusinessFunction', s: { i: 'Enumeration' } }, { i: 'BuyAction', s: { i: 'TradeAction' } }, { i: 'CableOrSatelliteService', s: { i: 'Service' } }, { i: 'CafeOrCoffeeShop', s: { i: 'FoodEstablishment' } }, { i: 'Campground', s: { i: 'CivicStructure' } }, { i: 'Canal', s: { i: 'BodyOfWater' } }, { i: 'CancelAction', s: { i: 'PlanAction' } }, { i: 'Car', s: { i: 'Vehicle' } }, { i: 'CarUsageType', s: { i: 'QualitativeValue' } }, { i: 'Casino', s: { i: 'EntertainmentBusiness' } }, { i: 'CatholicChurch', s: { i: 'PlaceOfWorship' } }, { i: 'Cemetery', s: { i: 'CivicStructure' } }, { i: 'CheckAction', s: { i: 'FindAction' } }, { i: 'CheckInAction', s: { i: 'CommunicateAction' } }, { i: 'CheckOutAction', s: { i: 'CommunicateAction' } }, { i: 'CheckoutPage', s: { i: 'WebPage' } }, { i: 'ChildCare', s: { i: 'LocalBusiness' } }, { i: 'ChildrensEvent', s: { i: 'Event' } }, { i: 'ChooseAction', s: { i: 'AssessAction' } }, { i: 'Church', s: { i: 'PlaceOfWorship' } }, { i: 'City', s: { i: 'AdministrativeArea' } }, { i: 'CityHall', s: { i: 'GovernmentBuilding' } }, { i: 'CivicStructure', s: { i: 'Place' } }, { i: 'Class', s: { i: 'Intangible' } }, { i: 'Clip', s: { i: 'CreativeWork' } }, { i: 'ClothingStore', s: { i: 'Store' } }, { i: 'Code', s: { i: 'CreativeWork' } }, { i: 'CollectionPage', s: { i: 'WebPage' } }, { i: 'CollegeOrUniversity', s: { i: 'EducationalOrganization' } }, { i: 'ComedyClub', s: { i: 'EntertainmentBusiness' } }, { i: 'ComedyEvent', s: { i: 'Event' } }, { i: 'Comment', s: { i: 'CreativeWork' } }, { i: 'CommentAction', s: { i: 'CommunicateAction' } }, { i: 'CommunicateAction', s: { i: 'InteractAction' } }, { i: 'ComputerStore', s: { i: 'Store' } }, { i: 'ConfirmAction', s: { i: 'InformAction' } }, { i: 'ConsumeAction', s: { i: 'Action' } }, { i: 'ContactPage', s: { i: 'WebPage' } }, { i: 'ContactPoint', s: { i: 'StructuredValue' } }, { i: 'ContactPointOption', s: { i: 'Enumeration' } }, { i: 'Continent', s: { i: 'Landform' } }, { i: 'ControlAction', s: { i: 'Action' } }, { i: 'ConvenienceStore', s: { i: 'Store' } }, { i: 'CookAction', s: { i: 'CreateAction' } }, { i: 'Corporation', s: { i: 'Organization' } }, { i: 'Country', s: { i: 'AdministrativeArea' } }, { i: 'Courthouse', s: { i: 'GovernmentBuilding' } }, { i: 'CreateAction', s: { i: 'Action' } }, { i: 'CreativeWork', s: { i: 'Thing' } }, { i: 'CreativeWorkSeason', s: { i: 'CreativeWork' } }, { i: 'CreativeWorkSeries', s: { i: 'CreativeWork' } }, { i: 'CreditCard', s: { i: 'PaymentMethod' } }, { i: 'Crematorium', s: { i: 'CivicStructure' } }, { i: 'DDxElement', s: { i: 'MedicalIntangible' } }, { i: 'DanceEvent', s: { i: 'Event' } }, { i: 'DanceGroup', s: { i: 'PerformingGroup' } }, { i: 'DataCatalog', s: { i: 'CreativeWork' } }, { i: 'DataDownload', s: { i: 'MediaObject' } }, { i: 'DataFeed', s: { i: 'Dataset' } }, { i: 'DataFeedItem', s: { i: 'Intangible' } }, { i: 'DataType', s: { i: 'rdfs:Class' } }, { i: 'Dataset', s: { i: 'CreativeWork' } }, { i: 'DatedMoneySpecification', s: { i: 'StructuredValue' } }, { i: 'DayOfWeek', s: { i: 'Enumeration' } }, { i: 'DaySpa', s: { i: 'HealthAndBeautyBusiness' } }, { i: 'DeactivateAction', s: { i: 'ControlAction' } }, { i: 'DefenceEstablishment', s: { i: 'GovernmentBuilding' } }, { i: 'DeleteAction', s: { i: 'UpdateAction' } }, { i: 'DeliveryChargeSpecification', s: { i: 'PriceSpecification' } }, { i: 'DeliveryEvent', s: { i: 'Event' } }, { i: 'DeliveryMethod', s: { i: 'Enumeration' } }, { i: 'Demand', s: { i: 'Intangible' } }, { i: 'Dentist', s: { i: 'MedicalOrganization' } }, { i: 'DepartAction', s: { i: 'MoveAction' } }, { i: 'DepartmentStore', s: { i: 'Store' } }, { i: 'DiagnosticLab', s: { i: 'MedicalOrganization' } }, { i: 'DiagnosticProcedure', s: [{ i: 'MedicalTest' }, { i: 'MedicalProcedure' }] }, { i: 'Diet', s: [{ i: 'LifestyleModification' }, { i: 'CreativeWork' }] }, { i: 'DietarySupplement', s: { i: 'MedicalTherapy' } }, { i: 'DisagreeAction', s: { i: 'ReactAction' } }, { i: 'DiscoverAction', s: { i: 'FindAction' } }, { i: 'DiscussionForumPosting', s: { i: 'SocialMediaPosting' } }, { i: 'DislikeAction', s: { i: 'ReactAction' } }, { i: 'Distance', s: { i: 'Quantity' } }, { i: 'DonateAction', s: { i: 'TradeAction' } }, { i: 'DoseSchedule', s: { i: 'MedicalIntangible' } }, { i: 'DownloadAction', s: { i: 'TransferAction' } }, { i: 'DrawAction', s: { i: 'CreateAction' } }, { i: 'DrinkAction', s: { i: 'ConsumeAction' } }, { i: 'DriveWheelConfigurationValue', s: { i: 'QualitativeValue' } }, { i: 'Drug', s: { i: 'MedicalTherapy' } }, { i: 'DrugClass', s: { i: 'MedicalTherapy' } }, { i: 'DrugCost', s: { i: 'MedicalIntangible' } }, { i: 'DrugCostCategory', s: [{ i: 'MedicalEnumeration' }, { i: 'Enumeration' }] }, { i: 'DrugLegalStatus', s: { i: 'MedicalIntangible' } }, { i: 'DrugPregnancyCategory', s: [{ i: 'MedicalEnumeration' }, { i: 'Enumeration' }] }, { i: 'DrugPrescriptionStatus', s: [{ i: 'MedicalEnumeration' }, { i: 'Enumeration' }] }, { i: 'DrugStrength', s: { i: 'MedicalIntangible' } }, { i: 'DryCleaningOrLaundry', s: { i: 'LocalBusiness' } }, { i: 'Duration', s: { i: 'Quantity' } }, { i: 'EatAction', s: { i: 'ConsumeAction' } }, { i: 'EducationEvent', s: { i: 'Event' } }, { i: 'EducationalAudience', s: { i: 'Audience' } }, { i: 'EducationalOrganization', s: { i: 'Organization' } }, { i: 'Electrician', s: { i: 'HomeAndConstructionBusiness' } }, { i: 'ElectronicsStore', s: { i: 'Store' } }, { i: 'ElementarySchool', s: { i: 'EducationalOrganization' } }, { i: 'EmailMessage', s: { i: 'CreativeWork' } }, { i: 'Embassy', s: { i: 'GovernmentBuilding' } }, { i: 'EmergencyService', s: { i: 'LocalBusiness' } }, { i: 'EmployeeRole', s: { i: 'OrganizationRole' } }, { i: 'EmploymentAgency', s: { i: 'LocalBusiness' } }, { i: 'EndorseAction', s: { i: 'ReactAction' } }, { i: 'Energy', s: { i: 'Quantity' } }, { i: 'EngineSpecification', s: { i: 'StructuredValue' } }, { i: 'EntertainmentBusiness', s: { i: 'LocalBusiness' } }, { i: 'EntryPoint', s: { i: 'Intangible' } }, { i: 'Enumeration', s: { i: 'Intangible' } }, { i: 'Episode', s: { i: 'CreativeWork' } }, { i: 'Event', s: { i: 'Thing' } }, { i: 'EventReservation', s: { i: 'Reservation' } }, { i: 'EventStatusType', s: { i: 'Enumeration' } }, { i: 'EventVenue', s: { i: 'CivicStructure' } }, { i: 'ExerciseAction', s: { i: 'PlayAction' } }, { i: 'ExerciseGym', s: { i: 'SportsActivityLocation' } }, { i: 'ExercisePlan', s: [{ i: 'CreativeWork' }, { i: 'PhysicalActivity' }] }, { i: 'ExhibitionEvent', s: { i: 'Event' } }, { i: 'FastFoodRestaurant', s: { i: 'FoodEstablishment' } }, { i: 'Festival', s: { i: 'Event' } }, { i: 'FilmAction', s: { i: 'CreateAction' } }, { i: 'FinancialService', s: { i: 'LocalBusiness' } }, { i: 'FindAction', s: { i: 'Action' } }, { i: 'FireStation', s: [{ i: 'CivicStructure' }, { i: 'EmergencyService' }] }, { i: 'Flight', s: { i: 'Intangible' } }, { i: 'FlightReservation', s: { i: 'Reservation' } }, { i: 'Float', s: { i: 'Number' } }, { i: 'Florist', s: { i: 'Store' } }, { i: 'FollowAction', s: { i: 'InteractAction' } }, { i: 'FoodEstablishment', s: { i: 'LocalBusiness' } }, { i: 'FoodEstablishmentReservation', s: { i: 'Reservation' } }, { i: 'FoodEvent', s: { i: 'Event' } }, { i: 'FurnitureStore', s: { i: 'Store' } }, { i: 'Game', s: { i: 'CreativeWork' } }, { i: 'GamePlayMode', s: { i: 'Enumeration' } }, { i: 'GameServer', s: { i: 'Intangible' } }, { i: 'GameServerStatus', s: { i: 'Enumeration' } }, { i: 'GardenStore', s: { i: 'Store' } }, { i: 'GasStation', s: { i: 'AutomotiveBusiness' } }, { i: 'GatedResidenceCommunity', s: { i: 'Residence' } }, { i: 'GeneralContractor', s: { i: 'HomeAndConstructionBusiness' } }, { i: 'GeoCircle', s: { i: 'GeoShape' } }, { i: 'GeoCoordinates', s: { i: 'StructuredValue' } }, { i: 'GeoShape', s: { i: 'StructuredValue' } }, { i: 'GiveAction', s: { i: 'TransferAction' } }, { i: 'GolfCourse', s: { i: 'SportsActivityLocation' } }, { i: 'GovernmentBuilding', s: { i: 'CivicStructure' } }, { i: 'GovernmentOffice', s: { i: 'LocalBusiness' } }, { i: 'GovernmentOrganization', s: { i: 'Organization' } }, { i: 'GovernmentPermit', s: { i: 'Permit' } }, { i: 'GovernmentService', s: { i: 'Service' } }, { i: 'GroceryStore', s: { i: 'Store' } }, { i: 'HVACBusiness', s: { i: 'HomeAndConstructionBusiness' } }, { i: 'HairSalon', s: { i: 'HealthAndBeautyBusiness' } }, { i: 'HardwareStore', s: { i: 'Store' } }, { i: 'HealthAndBeautyBusiness', s: { i: 'LocalBusiness' } }, { i: 'HealthClub', s: [{ i: 'SportsActivityLocation' }, { i: 'HealthAndBeautyBusiness' }] }, { i: 'HighSchool', s: { i: 'EducationalOrganization' } }, { i: 'HinduTemple', s: { i: 'PlaceOfWorship' } }, { i: 'HobbyShop', s: { i: 'Store' } }, { i: 'HomeAndConstructionBusiness', s: { i: 'LocalBusiness' } }, { i: 'HomeGoodsStore', s: { i: 'Store' } }, { i: 'Hospital', s: [{ i: 'MedicalOrganization' }, { i: 'CivicStructure' }, { i: 'EmergencyService' }] }, { i: 'Hostel', s: { i: 'LodgingBusiness' } }, { i: 'Hotel', s: { i: 'LodgingBusiness' } }, { i: 'HousePainter', s: { i: 'HomeAndConstructionBusiness' } }, { i: 'IceCreamShop', s: { i: 'FoodEstablishment' } }, { i: 'IgnoreAction', s: { i: 'AssessAction' } }, { i: 'ImageGallery', s: { i: 'CollectionPage' } }, { i: 'ImageObject', s: { i: 'MediaObject' } }, { i: 'ImagingTest', s: { i: 'MedicalTest' } }, { i: 'IndividualProduct', s: { i: 'Product' } }, { i: 'InfectiousAgentClass', s: [{ i: 'MedicalEnumeration' }, { i: 'Enumeration' }] }, { i: 'InfectiousDisease', s: { i: 'MedicalCondition' } }, { i: 'InformAction', s: { i: 'CommunicateAction' } }, { i: 'InsertAction', s: { i: 'AddAction' } }, { i: 'InstallAction', s: { i: 'ConsumeAction' } }, { i: 'InsuranceAgency', s: { i: 'FinancialService' } }, { i: 'Intangible', s: { i: 'Thing' } }, { i: 'Integer', s: { i: 'Number' } }, { i: 'InteractAction', s: { i: 'Action' } }, { i: 'InteractionCounter', s: { i: 'StructuredValue' } }, { i: 'InternetCafe', s: { i: 'LocalBusiness' } }, { i: 'InviteAction', s: { i: 'CommunicateAction' } }, { i: 'Invoice', s: { i: 'Intangible' } }, { i: 'ItemAvailability', s: { i: 'Enumeration' } }, { i: 'ItemList', s: { i: 'Intangible' } }, { i: 'ItemListOrderType', s: { i: 'Enumeration' } }, { i: 'ItemPage', s: { i: 'WebPage' } }, { i: 'JewelryStore', s: { i: 'Store' } }, { i: 'JobPosting', s: { i: 'Intangible' } }, { i: 'JoinAction', s: { i: 'InteractAction' } }, { i: 'Joint', s: { i: 'AnatomicalStructure' } }, { i: 'LakeBodyOfWater', s: { i: 'BodyOfWater' } }, { i: 'Landform', s: { i: 'Place' } }, { i: 'LandmarksOrHistoricalBuildings', s: { i: 'Place' } }, { i: 'Language', s: { i: 'Intangible' } }, { i: 'LeaveAction', s: { i: 'InteractAction' } }, { i: 'LegalService', s: { i: 'LocalBusiness' } }, { i: 'LegislativeBuilding', s: { i: 'GovernmentBuilding' } }, { i: 'LendAction', s: { i: 'TransferAction' } }, { i: 'Library', s: { i: 'LocalBusiness' } }, { i: 'LifestyleModification', s: { i: 'MedicalTherapy' } }, { i: 'Ligament', s: { i: 'AnatomicalStructure' } }, { i: 'LikeAction', s: { i: 'ReactAction' } }, { i: 'LiquorStore', s: { i: 'Store' } }, { i: 'ListItem', s: { i: 'Intangible' } }, { i: 'ListenAction', s: { i: 'ConsumeAction' } }, { i: 'LiteraryEvent', s: { i: 'Event' } }, { i: 'LiveBlogPosting', s: { i: 'BlogPosting' } }, { i: 'LocalBusiness', s: [{ i: 'Organization' }, { i: 'Place' }] }, { i: 'LockerDelivery', s: { i: 'DeliveryMethod' } }, { i: 'Locksmith', s: { i: 'HomeAndConstructionBusiness' } }, { i: 'LodgingBusiness', s: { i: 'LocalBusiness' } }, { i: 'LodgingReservation', s: { i: 'Reservation' } }, { i: 'LoseAction', s: { i: 'AchieveAction' } }, { i: 'LymphaticVessel', s: { i: 'Vessel' } }, { i: 'Map', s: { i: 'CreativeWork' } }, { i: 'MapCategoryType', s: { i: 'Enumeration' } }, { i: 'MarryAction', s: { i: 'InteractAction' } }, { i: 'Mass', s: { i: 'Quantity' } }, { i: 'MaximumDoseSchedule', s: { i: 'DoseSchedule' } }, { i: 'MediaObject', s: { i: 'CreativeWork' } }, { i: 'MedicalAudience', s: [{ i: 'PeopleAudience' }, { i: 'Enumeration' }, { i: 'Audience' }, { i: 'MedicalEnumeration' }] }, { i: 'MedicalCause', s: { i: 'MedicalEntity' } }, { i: 'MedicalClinic', s: { i: 'MedicalOrganization' } }, { i: 'MedicalCode', s: { i: 'MedicalIntangible' } }, { i: 'MedicalCondition', s: { i: 'MedicalEntity' } }, { i: 'MedicalConditionStage', s: { i: 'MedicalIntangible' } }, { i: 'MedicalContraindication', s: { i: 'MedicalEntity' } }, { i: 'MedicalDevice', s: { i: 'MedicalEntity' } }, { i: 'MedicalDevicePurpose', s: [{ i: 'MedicalEnumeration' }, { i: 'Enumeration' }] }, { i: 'MedicalEntity', s: { i: 'Thing' } }, { i: 'MedicalEnumeration', s: [{ i: 'MedicalIntangible' }, { i: 'Enumeration' }] }, { i: 'MedicalEvidenceLevel', s: [{ i: 'MedicalEnumeration' }, { i: 'Enumeration' }] }, { i: 'MedicalGuideline', s: { i: 'MedicalEntity' } }, { i: 'MedicalGuidelineContraindication', s: { i: 'MedicalGuideline' } }, { i: 'MedicalGuidelineRecommendation', s: { i: 'MedicalGuideline' } }, { i: 'MedicalImagingTechnique', s: [{ i: 'MedicalEnumeration' }, { i: 'Enumeration' }] }, { i: 'MedicalIndication', s: { i: 'MedicalEntity' } }, { i: 'MedicalIntangible', s: { i: 'MedicalEntity' } }, { i: 'MedicalObservationalStudy', s: { i: 'MedicalStudy' } }, { i: 'MedicalObservationalStudyDesign', s: [{ i: 'MedicalEnumeration' }, { i: 'Enumeration' }] }, { i: 'MedicalOrganization', s: { i: 'LocalBusiness' } }, { i: 'MedicalProcedure', s: { i: 'MedicalEntity' } }, { i: 'MedicalProcedureType', s: [{ i: 'Enumeration' }, { i: 'MedicalEnumeration' }] }, { i: 'MedicalRiskCalculator', s: { i: 'MedicalRiskEstimator' } }, { i: 'MedicalRiskEstimator', s: { i: 'MedicalEntity' } }, { i: 'MedicalRiskFactor', s: { i: 'MedicalEntity' } }, { i: 'MedicalRiskScore', s: { i: 'MedicalRiskEstimator' } }, { i: 'MedicalScholarlyArticle', s: { i: 'ScholarlyArticle' } }, { i: 'MedicalSign', s: { i: 'MedicalSignOrSymptom' } }, { i: 'MedicalSignOrSymptom', s: { i: 'MedicalEntity' } }, { i: 'MedicalSpecialty', s: [{ i: 'MedicalEnumeration' }, { i: 'Specialty' }, { i: 'Enumeration' }] }, { i: 'MedicalStudy', s: { i: 'MedicalEntity' } }, { i: 'MedicalStudyStatus', s: [{ i: 'MedicalEnumeration' }, { i: 'Enumeration' }] }, { i: 'MedicalSymptom', s: { i: 'MedicalSignOrSymptom' } }, { i: 'MedicalTest', s: { i: 'MedicalEntity' } }, { i: 'MedicalTestPanel', s: { i: 'MedicalTest' } }, { i: 'MedicalTherapy', s: { i: 'MedicalEntity' } }, { i: 'MedicalTrial', s: { i: 'MedicalStudy' } }, { i: 'MedicalTrialDesign', s: [{ i: 'MedicalEnumeration' }, { i: 'Enumeration' }] }, { i: 'MedicalWebPage', s: { i: 'WebPage' } }, { i: 'MedicineSystem', s: [{ i: 'Enumeration' }, { i: 'MedicalEnumeration' }] }, { i: 'MensClothingStore', s: { i: 'Store' } }, { i: 'MiddleSchool', s: { i: 'EducationalOrganization' } }, { i: 'MobileApplication', s: { i: 'SoftwareApplication' } }, { i: 'MobilePhoneStore', s: { i: 'Store' } }, { i: 'Mosque', s: { i: 'PlaceOfWorship' } }, { i: 'Motel', s: { i: 'LodgingBusiness' } }, { i: 'MotorcycleDealer', s: { i: 'AutomotiveBusiness' } }, { i: 'MotorcycleRepair', s: { i: 'AutomotiveBusiness' } }, { i: 'Mountain', s: { i: 'Landform' } }, { i: 'MoveAction', s: { i: 'Action' } }, { i: 'Movie', s: { i: 'CreativeWork' } }, { i: 'MovieClip', s: { i: 'Clip' } }, { i: 'MovieRentalStore', s: { i: 'Store' } }, { i: 'MovieSeries', s: { i: 'CreativeWorkSeries' } }, { i: 'MovieTheater', s: [{ i: 'EntertainmentBusiness' }, { i: 'CivicStructure' }] }, { i: 'MovingCompany', s: { i: 'HomeAndConstructionBusiness' } }, { i: 'Muscle', s: { i: 'AnatomicalStructure' } }, { i: 'Museum', s: { i: 'CivicStructure' } }, { i: 'MusicAlbum', s: { i: 'MusicPlaylist' } }, { i: 'MusicAlbumProductionType', s: { i: 'Enumeration' } }, { i: 'MusicAlbumReleaseType', s: { i: 'Enumeration' } }, { i: 'MusicComposition', s: { i: 'CreativeWork' } }, { i: 'MusicEvent', s: { i: 'Event' } }, { i: 'MusicGroup', s: { i: 'PerformingGroup' } }, { i: 'MusicPlaylist', s: { i: 'CreativeWork' } }, { i: 'MusicRecording', s: { i: 'CreativeWork' } }, { i: 'MusicRelease', s: { i: 'MusicPlaylist' } }, { i: 'MusicReleaseFormatType', s: { i: 'Enumeration' } }, { i: 'MusicStore', s: { i: 'Store' } }, { i: 'MusicVenue', s: { i: 'CivicStructure' } }, { i: 'MusicVideoObject', s: { i: 'MediaObject' } }, { i: 'NGO', s: { i: 'Organization' } }, { i: 'NailSalon', s: { i: 'HealthAndBeautyBusiness' } }, { i: 'Nerve', s: { i: 'AnatomicalStructure' } }, { i: 'NewsArticle', s: { i: 'Article' } }, { i: 'NightClub', s: { i: 'EntertainmentBusiness' } }, { i: 'Notary', s: { i: 'LegalService' } }, { i: 'NutritionInformation', s: { i: 'StructuredValue' } }, { i: 'OceanBodyOfWater', s: { i: 'BodyOfWater' } }, { i: 'Offer', s: { i: 'Intangible' } }, { i: 'OfferCatalog', s: { i: 'ItemList' } }, { i: 'OfferItemCondition', s: { i: 'Enumeration' } }, { i: 'OfficeEquipmentStore', s: { i: 'Store' } }, { i: 'OnDemandEvent', s: { i: 'PublicationEvent' } }, { i: 'OpeningHoursSpecification', s: { i: 'StructuredValue' } }, { i: 'Optician', s: { i: 'MedicalOrganization' } }, { i: 'Order', s: { i: 'Intangible' } }, { i: 'OrderAction', s: { i: 'TradeAction' } }, { i: 'OrderItem', s: { i: 'Intangible' } }, { i: 'OrderStatus', s: { i: 'Enumeration' } }, { i: 'Organization', s: { i: 'Thing' } }, { i: 'OrganizationRole', s: { i: 'Role' } }, { i: 'OrganizeAction', s: { i: 'Action' } }, { i: 'OutletStore', s: { i: 'Store' } }, { i: 'OwnershipInfo', s: { i: 'StructuredValue' } }, { i: 'PaintAction', s: { i: 'CreateAction' } }, { i: 'Painting', s: { i: 'CreativeWork' } }, { i: 'PalliativeProcedure', s: [{ i: 'MedicalProcedure' }, { i: 'MedicalTherapy' }] }, { i: 'ParcelDelivery', s: { i: 'Intangible' } }, { i: 'ParcelService', s: { i: 'DeliveryMethod' } }, { i: 'ParentAudience', s: { i: 'PeopleAudience' } }, { i: 'Park', s: { i: 'CivicStructure' } }, { i: 'ParkingFacility', s: { i: 'CivicStructure' } }, { i: 'PathologyTest', s: { i: 'MedicalTest' } }, { i: 'PawnShop', s: { i: 'Store' } }, { i: 'PayAction', s: { i: 'TradeAction' } }, { i: 'PaymentChargeSpecification', s: { i: 'PriceSpecification' } }, { i: 'PaymentMethod', s: { i: 'Enumeration' } }, { i: 'PaymentStatusType', s: { i: 'Enumeration' } }, { i: 'PeopleAudience', s: { i: 'Audience' } }, { i: 'PerformAction', s: { i: 'PlayAction' } }, { i: 'PerformanceRole', s: { i: 'Role' } }, { i: 'PerformingArtsTheater', s: { i: 'CivicStructure' } }, { i: 'PerformingGroup', s: { i: 'Organization' } }, { i: 'Periodical', s: { i: 'CreativeWorkSeries' } }, { i: 'Permit', s: { i: 'Intangible' } }, { i: 'Person', s: { i: 'Thing' } }, { i: 'PetStore', s: { i: 'Store' } }, { i: 'Pharmacy', s: { i: 'MedicalOrganization' } }, { i: 'Photograph', s: { i: 'CreativeWork' } }, { i: 'PhotographAction', s: { i: 'CreateAction' } }, { i: 'PhysicalActivity', s: { i: 'LifestyleModification' } }, { i: 'PhysicalActivityCategory', s: [{ i: 'MedicalEnumeration' }, { i: 'Enumeration' }] }, { i: 'PhysicalExam', s: [{ i: 'Enumeration' }, { i: 'MedicalEnumeration' }] }, { i: 'PhysicalTherapy', s: { i: 'MedicalTherapy' } }, { i: 'Physician', s: { i: 'MedicalOrganization' } }, { i: 'Place', s: { i: 'Thing' } }, { i: 'PlaceOfWorship', s: { i: 'CivicStructure' } }, { i: 'PlanAction', s: { i: 'OrganizeAction' } }, { i: 'PlayAction', s: { i: 'Action' } }, { i: 'Playground', s: { i: 'CivicStructure' } }, { i: 'Plumber', s: { i: 'HomeAndConstructionBusiness' } }, { i: 'PoliceStation', s: [{ i: 'EmergencyService' }, { i: 'CivicStructure' }] }, { i: 'Pond', s: { i: 'BodyOfWater' } }, { i: 'PostOffice', s: { i: 'GovernmentOffice' } }, { i: 'PostalAddress', s: { i: 'ContactPoint' } }, { i: 'PrependAction', s: { i: 'InsertAction' } }, { i: 'Preschool', s: { i: 'EducationalOrganization' } }, { i: 'PreventionIndication', s: { i: 'MedicalIndication' } }, { i: 'PriceSpecification', s: { i: 'StructuredValue' } }, { i: 'Product', s: { i: 'Thing' } }, { i: 'ProductModel', s: { i: 'Product' } }, { i: 'ProfessionalService', s: { i: 'LocalBusiness' } }, { i: 'ProfilePage', s: { i: 'WebPage' } }, { i: 'ProgramMembership', s: { i: 'Intangible' } }, { i: 'Property', s: { i: 'Intangible' } }, { i: 'PropertyValue', s: { i: 'StructuredValue' } }, { i: 'PropertyValueSpecification', s: { i: 'Intangible' } }, { i: 'PsychologicalTreatment', s: { i: 'MedicalTherapy' } }, { i: 'PublicSwimmingPool', s: { i: 'SportsActivityLocation' } }, { i: 'PublicationEvent', s: { i: 'Event' } }, { i: 'PublicationIssue', s: { i: 'CreativeWork' } }, { i: 'PublicationVolume', s: { i: 'CreativeWork' } }, { i: 'QAPage', s: { i: 'WebPage' } }, { i: 'QualitativeValue', s: { i: 'Enumeration' } }, { i: 'QuantitativeValue', s: { i: 'StructuredValue' } }, { i: 'Quantity', s: { i: 'Intangible' } }, { i: 'Question', s: { i: 'CreativeWork' } }, { i: 'QuoteAction', s: { i: 'TradeAction' } }, { i: 'RVPark', s: { i: 'CivicStructure' } }, { i: 'RadiationTherapy', s: { i: 'MedicalTherapy' } }, { i: 'RadioChannel', s: { i: 'BroadcastChannel' } }, { i: 'RadioClip', s: { i: 'Clip' } }, { i: 'RadioEpisode', s: { i: 'Episode' } }, { i: 'RadioSeason', s: { i: 'CreativeWorkSeason' } }, { i: 'RadioSeries', s: { i: 'CreativeWorkSeries' } }, { i: 'RadioStation', s: { i: 'LocalBusiness' } }, { i: 'Rating', s: { i: 'Intangible' } }, { i: 'ReactAction', s: { i: 'AssessAction' } }, { i: 'ReadAction', s: { i: 'ConsumeAction' } }, { i: 'RealEstateAgent', s: { i: 'LocalBusiness' } }, { i: 'ReceiveAction', s: { i: 'TransferAction' } }, { i: 'Recipe', s: { i: 'CreativeWork' } }, { i: 'RecommendedDoseSchedule', s: { i: 'DoseSchedule' } }, { i: 'RecyclingCenter', s: { i: 'LocalBusiness' } }, { i: 'RegisterAction', s: { i: 'InteractAction' } }, { i: 'RejectAction', s: { i: 'AllocateAction' } }, { i: 'RentAction', s: { i: 'TradeAction' } }, { i: 'RentalCarReservation', s: { i: 'Reservation' } }, { i: 'ReplaceAction', s: { i: 'UpdateAction' } }, { i: 'ReplyAction', s: { i: 'CommunicateAction' } }, { i: 'Report', s: { i: 'Article' } }, { i: 'ReportedDoseSchedule', s: { i: 'DoseSchedule' } }, { i: 'Reservation', s: { i: 'Intangible' } }, { i: 'ReservationPackage', s: { i: 'Reservation' } }, { i: 'ReservationStatusType', s: { i: 'Enumeration' } }, { i: 'ReserveAction', s: { i: 'PlanAction' } }, { i: 'Reservoir', s: { i: 'BodyOfWater' } }, { i: 'Residence', s: { i: 'Place' } }, { i: 'Restaurant', s: { i: 'FoodEstablishment' } }, { i: 'ResumeAction', s: { i: 'ControlAction' } }, { i: 'ReturnAction', s: { i: 'TransferAction' } }, { i: 'Review', s: { i: 'CreativeWork' } }, { i: 'ReviewAction', s: { i: 'AssessAction' } }, { i: 'RiverBodyOfWater', s: { i: 'BodyOfWater' } }, { i: 'Role', s: { i: 'Intangible' } }, { i: 'RoofingContractor', s: { i: 'HomeAndConstructionBusiness' } }, { i: 'RsvpAction', s: { i: 'InformAction' } }, { i: 'RsvpResponseType', s: { i: 'Enumeration' } }, { i: 'SaleEvent', s: { i: 'Event' } }, { i: 'ScheduleAction', s: { i: 'PlanAction' } }, { i: 'ScholarlyArticle', s: { i: 'Article' } }, { i: 'School', s: { i: 'EducationalOrganization' } }, { i: 'ScreeningEvent', s: { i: 'Event' } }, { i: 'Sculpture', s: { i: 'CreativeWork' } }, { i: 'SeaBodyOfWater', s: { i: 'BodyOfWater' } }, { i: 'SearchAction', s: { i: 'Action' } }, { i: 'SearchResultsPage', s: { i: 'WebPage' } }, { i: 'Season', s: { i: 'CreativeWork' } }, { i: 'Seat', s: { i: 'Intangible' } }, { i: 'SelfStorage', s: { i: 'LocalBusiness' } }, { i: 'SellAction', s: { i: 'TradeAction' } }, { i: 'SendAction', s: { i: 'TransferAction' } }, { i: 'Series', s: { i: 'CreativeWork' } }, { i: 'Service', s: { i: 'Intangible' } }, { i: 'ServiceChannel', s: { i: 'Intangible' } }, { i: 'ShareAction', s: { i: 'CommunicateAction' } }, { i: 'ShoeStore', s: { i: 'Store' } }, { i: 'ShoppingCenter', s: { i: 'LocalBusiness' } }, { i: 'SingleFamilyResidence', s: { i: 'Residence' } }, { i: 'SiteNavigationElement', s: { i: 'WebPageElement' } }, { i: 'SkiResort', s: { i: 'SportsActivityLocation' } }, { i: 'SocialEvent', s: { i: 'Event' } }, { i: 'SocialMediaPosting', s: { i: 'Article' } }, { i: 'SoftwareApplication', s: { i: 'CreativeWork' } }, { i: 'SoftwareSourceCode', s: { i: 'CreativeWork' } }, { i: 'SomeProducts', s: { i: 'Product' } }, { i: 'Specialty', s: { i: 'Enumeration' } }, { i: 'SportingGoodsStore', s: { i: 'Store' } }, { i: 'SportsActivityLocation', s: { i: 'LocalBusiness' } }, { i: 'SportsClub', s: { i: 'SportsActivityLocation' } }, { i: 'SportsEvent', s: { i: 'Event' } }, { i: 'SportsOrganization', s: { i: 'Organization' } }, { i: 'SportsTeam', s: { i: 'SportsOrganization' } }, { i: 'StadiumOrArena', s: [{ i: 'SportsActivityLocation' }, { i: 'CivicStructure' }] }, { i: 'State', s: { i: 'AdministrativeArea' } }, { i: 'SteeringPositionValue', s: { i: 'QualitativeValue' } }, { i: 'Store', s: { i: 'LocalBusiness' } }, { i: 'StructuredValue', s: { i: 'Intangible' } }, { i: 'SubscribeAction', s: { i: 'InteractAction' } }, { i: 'SubwayStation', s: { i: 'CivicStructure' } }, { i: 'SuperficialAnatomy', s: { i: 'MedicalEntity' } }, { i: 'SuspendAction', s: { i: 'ControlAction' } }, { i: 'Synagogue', s: { i: 'PlaceOfWorship' } }, { i: 'TVClip', s: { i: 'Clip' } }, { i: 'TVEpisode', s: { i: 'Episode' } }, { i: 'TVSeason', s: [{ i: 'CreativeWorkSeason' }, { i: 'CreativeWork' }] }, { i: 'TVSeries', s: [{ i: 'CreativeWorkSeries' }, { i: 'CreativeWork' }] }, { i: 'Table', s: { i: 'WebPageElement' } }, { i: 'TakeAction', s: { i: 'TransferAction' } }, { i: 'TattooParlor', s: { i: 'HealthAndBeautyBusiness' } }, { i: 'Taxi', s: { i: 'Service' } }, { i: 'TaxiReservation', s: { i: 'Reservation' } }, { i: 'TaxiService', s: { i: 'Service' } }, { i: 'TaxiStand', s: { i: 'CivicStructure' } }, { i: 'TechArticle', s: { i: 'Article' } }, { i: 'TelevisionChannel', s: { i: 'BroadcastChannel' } }, { i: 'TelevisionStation', s: { i: 'LocalBusiness' } }, { i: 'TennisComplex', s: { i: 'SportsActivityLocation' } }, { i: 'TheaterEvent', s: { i: 'Event' } }, { i: 'TheaterGroup', s: { i: 'PerformingGroup' } }, { i: 'TherapeuticProcedure', s: [{ i: 'MedicalProcedure' }, { i: 'MedicalTherapy' }] }, { i: 'Thing' }, { i: 'Ticket', s: { i: 'Intangible' } }, { i: 'TieAction', s: { i: 'AchieveAction' } }, { i: 'TipAction', s: { i: 'TradeAction' } }, { i: 'TireShop', s: { i: 'Store' } }, { i: 'TouristAttraction', s: { i: 'Place' } }, { i: 'TouristInformationCenter', s: { i: 'LocalBusiness' } }, { i: 'ToyStore', s: { i: 'Store' } }, { i: 'TrackAction', s: { i: 'FindAction' } }, { i: 'TradeAction', s: { i: 'Action' } }, { i: 'TrainReservation', s: { i: 'Reservation' } }, { i: 'TrainStation', s: { i: 'CivicStructure' } }, { i: 'TrainTrip', s: { i: 'Intangible' } }, { i: 'TransferAction', s: { i: 'Action' } }, { i: 'TravelAction', s: { i: 'MoveAction' } }, { i: 'TravelAgency', s: { i: 'LocalBusiness' } }, { i: 'TreatmentIndication', s: { i: 'MedicalIndication' } }, { i: 'TypeAndQuantityNode', s: { i: 'StructuredValue' } }, { i: 'URL', s: { i: 'Text' } }, { i: 'UnRegisterAction', s: { i: 'InteractAction' } }, { i: 'UnitPriceSpecification', s: { i: 'PriceSpecification' } }, { i: 'UpdateAction', s: { i: 'Action' } }, { i: 'UseAction', s: { i: 'ConsumeAction' } }, { i: 'UserBlocks', s: { i: 'UserInteraction' } }, { i: 'UserCheckins', s: { i: 'UserInteraction' } }, { i: 'UserComments', s: { i: 'UserInteraction' } }, { i: 'UserDownloads', s: { i: 'UserInteraction' } }, { i: 'UserInteraction', s: { i: 'Event' } }, { i: 'UserLikes', s: { i: 'UserInteraction' } }, { i: 'UserPageVisits', s: { i: 'UserInteraction' } }, { i: 'UserPlays', s: { i: 'UserInteraction' } }, { i: 'UserPlusOnes', s: { i: 'UserInteraction' } }, { i: 'UserTweets', s: { i: 'UserInteraction' } }, { i: 'Vehicle', s: { i: 'Product' } }, { i: 'Vein', s: { i: 'Vessel' } }, { i: 'Vessel', s: { i: 'AnatomicalStructure' } }, { i: 'VeterinaryCare', s: { i: 'MedicalOrganization' } }, { i: 'VideoGallery', s: { i: 'CollectionPage' } }, { i: 'VideoGame', s: [{ i: 'Game' }, { i: 'SoftwareApplication' }] }, { i: 'VideoGameClip', s: { i: 'Clip' } }, { i: 'VideoGameSeries', s: { i: 'CreativeWorkSeries' } }, { i: 'VideoObject', s: { i: 'MediaObject' } }, { i: 'ViewAction', s: { i: 'ConsumeAction' } }, { i: 'VisualArtsEvent', s: { i: 'Event' } }, { i: 'VisualArtwork', s: { i: 'CreativeWork' } }, { i: 'Volcano', s: { i: 'Landform' } }, { i: 'VoteAction', s: { i: 'ChooseAction' } }, { i: 'WPAdBlock', s: { i: 'WebPageElement' } }, { i: 'WPFooter', s: { i: 'WebPageElement' } }, { i: 'WPHeader', s: { i: 'WebPageElement' } }, { i: 'WPSideBar', s: { i: 'WebPageElement' } }, { i: 'WantAction', s: { i: 'ReactAction' } }, { i: 'WarrantyPromise', s: { i: 'StructuredValue' } }, { i: 'WarrantyScope', s: { i: 'Enumeration' } }, { i: 'WatchAction', s: { i: 'ConsumeAction' } }, { i: 'Waterfall', s: { i: 'BodyOfWater' } }, { i: 'WearAction', s: { i: 'UseAction' } }, { i: 'WebApplication', s: { i: 'SoftwareApplication' } }, { i: 'WebPage', s: { i: 'CreativeWork' } }, { i: 'WebPageElement', s: { i: 'CreativeWork' } }, { i: 'WebSite', s: { i: 'CreativeWork' } }, { i: 'WholesaleStore', s: { i: 'Store' } }, { i: 'WinAction', s: { i: 'AchieveAction' } }, { i: 'Winery', s: { i: 'FoodEstablishment' } }, { i: 'WriteAction', s: { i: 'CreateAction' } }, { i: 'Zoo', s: { i: 'CivicStructure' } }];

/***/ }),
/* 50 */
/*!**************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d29cbcd","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/InputClass.vue ***!
  \**************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "inp-subtle inp-type fragment-type",
    class: {
      'inp-type-active': _vm.options
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.submit($event)
      },
      "keydown": _vm.keydown
    }
  }, [_c('span', {
    staticClass: "inp-subtle-span",
    domProps: {
      "textContent": _vm._s(_vm.term || _vm.text)
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.term),
      expression: "term"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.text
    },
    domProps: {
      "value": (_vm.term)
    },
    on: {
      "blur": _vm.blur,
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.term = $event.target.value
      }, _vm.input],
      "focus": _vm.input
    }
  }), _vm._v(" "), (_vm.options) ? _c('div', {
    staticClass: "ref-select"
  }, [_c('div', {
    staticClass: "ref-scroll"
  }, _vm._l((_vm.options), function(opt, index) {
    return _c('div', {
      key: opt.item,
      staticClass: "ref-option",
      class: {
        'ref-ghost': index === _vm.ghost
      },
      domProps: {
        "textContent": _vm._s(opt.item + ' ' + opt.score)
      },
      on: {
        "mouseenter": function($event) {
          _vm.ghost = index
        },
        "mousedown": function($event) {
          _vm.confirm(opt.item)
        }
      }
    })
  }))]) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 51 */
/*!*************************************!*\
  !*** ./src/components/InputRaw.vue ***!
  \*************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_opt_build_repo_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_InputRaw_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/opt/build/repo/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./InputRaw.vue */ 53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e45e6486_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_InputRaw_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-e45e6486","hasScoped":false}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./InputRaw.vue */ 54);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-e45e6486","scoped":false,"hasInlineConfig":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./InputRaw.vue */ 52)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_opt_build_repo_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_InputRaw_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e45e6486_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_InputRaw_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 52 */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e45e6486","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/InputRaw.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 53 */
/*!****************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/opt/build/repo/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/InputRaw.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'input-json',
  props: ['value', 'placeholder'],
  data: function data() {
    return {
      invalid: false
    };
  },

  computed: {
    model: function model() {
      return JSON.stringify(this.value, null, 2);
    }
  },
  methods: {
    input: function input(evt, change) {
      var str = evt.target.value;
      try {
        var val = JSON.parse(str);
        if (val && val['@id'] && val['@type']) {
          this.invalid = false;
          this.freeze = true;
          if (change || val['@id'] === this.value['@id']) {
            this.$root.setFragment(val);
          }
        } else {
          this.invalid = str;
        }
      } catch (e) {
        this.invalid = str;
      }
    },
    change: function change(evt) {
      this.input(evt, true);
    }
  },
  mounted: function mounted() {
    this.$refs.ta.value = this.model;
  },

  watch: {
    value: function value() {
      if (this.freeze) {
        this.freeze = false;
      } else {
        this.$refs.ta.value = this.model;
      }
    }
  }
});

/***/ }),
/* 54 */
/*!************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e45e6486","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/InputRaw.vue ***!
  \************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "inp-subtle",
    staticStyle: {
      "white-space": "pre-wrap",
      "font-family": "consolas, monospace"
    }
  }, [_c('span', {
    staticClass: "inp-subtle-span",
    class: {
      'input-raw--invalid': _vm.invalid
    },
    domProps: {
      "textContent": _vm._s((_vm.invalid || _vm.model || _vm.placeholder) + '.')
    }
  }), _vm._v(" "), _c('textarea', {
    ref: "ta",
    staticClass: "input",
    attrs: {
      "placeholder": _vm.placeholder
    },
    on: {
      "input": _vm.input,
      "change": _vm.change
    }
  })])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 55 */
/*!*******************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/opt/build/repo/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/InputSubtle.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'input-subtle',
  props: ['value', 'placeholder'],
  computed: {
    model: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        this.$emit('input', val);
      }
    }
  }
});

/***/ }),
/* 56 */
/*!***************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b26b0ab0","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/InputSubtle.vue ***!
  \***************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "inp-subtle"
  }, [_c('span', {
    staticClass: "inp-subtle-span",
    domProps: {
      "textContent": _vm._s(_vm.value || _vm.placeholder)
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model),
      expression: "model"
    }],
    staticClass: "inp-big-focus",
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.model)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model = $event.target.value
      }
    }
  })])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 57 */
/*!***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6fe3f3bc","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Prop.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 58 */
/*!************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/opt/build/repo/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Prop.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ValueArray_vue__ = __webpack_require__(/*! ./ValueArray.vue */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ValueLiteral_vue__ = __webpack_require__(/*! ./ValueLiteral.vue */ 10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ValueObject_vue__ = __webpack_require__(/*! ./ValueObject.vue */ 5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ValueReference_vue__ = __webpack_require__(/*! ./ValueReference.vue */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ValueString_vue__ = __webpack_require__(/*! ./ValueString.vue */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ValueText_vue__ = __webpack_require__(/*! ./ValueText.vue */ 14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__libs_util_js__ = __webpack_require__(/*! ../libs/util.js */ 1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'prop',
  props: ['fragment', 'prop'],
  computed: {
    propClasses: function propClasses() {
      var level = this.$parent.level;
      var list = this.$root.listFocus;
      var isFocused = list[level] === this.prop;
      var distance = list.length - level;
      return {
        'focus-prop': isFocused && distance === 1,
        'focus-from': isFocused && distance > 1,
        'focus-sibling': !isFocused && distance > 0
      };
    },
    hasPropFocus: function hasPropFocus() {
      return this.propClasses['focus-prop'] || this.propClasses['focus-from'];
    },
    renderType: function renderType() {
      return Object(__WEBPACK_IMPORTED_MODULE_6__libs_util_js__["h" /* toType */])(this.fragment[this.prop]);
    },
    niceProp: function niceProp() {
      return typeof this.prop === 'string' && this.prop.substr(this.prop.indexOf(':') + 1);
    }
  },
  methods: {
    propFocus: function propFocus(val) {
      console.debug('propFocus', this.prop, val);
      this.$emit('focus', val);
    }
  },
  components: {
    ValueArray: __WEBPACK_IMPORTED_MODULE_0__ValueArray_vue__["a" /* default */],
    ValueLiteral: __WEBPACK_IMPORTED_MODULE_1__ValueLiteral_vue__["a" /* default */],
    ValueObject: __WEBPACK_IMPORTED_MODULE_2__ValueObject_vue__["a" /* default */],
    ValueReference: __WEBPACK_IMPORTED_MODULE_3__ValueReference_vue__["a" /* default */],
    ValueString: __WEBPACK_IMPORTED_MODULE_4__ValueString_vue__["a" /* default */],
    ValueText: __WEBPACK_IMPORTED_MODULE_5__ValueText_vue__["a" /* default */]
  }
});

/***/ }),
/* 59 */
/*!*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b5522332","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ValueArray.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 60 */
/*!******************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/opt/build/repo/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ValueArray.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_util_js__ = __webpack_require__(/*! ../libs/util.js */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ValueArray_vue__ = __webpack_require__(/*! ./ValueArray.vue */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ValueLiteral_vue__ = __webpack_require__(/*! ./ValueLiteral.vue */ 10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ValueObject_vue__ = __webpack_require__(/*! ./ValueObject.vue */ 5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ValueReference_vue__ = __webpack_require__(/*! ./ValueReference.vue */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ValueString_vue__ = __webpack_require__(/*! ./ValueString.vue */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ValueText_vue__ = __webpack_require__(/*! ./ValueText.vue */ 14);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'value-array',
  props: {
    value: {
      type: Array
    }
  },
  data: function data() {
    return {
      focusIndex: -1
    };
  },

  computed: {},
  methods: {
    key: function key(item) {
      return item && item['@id'];
    },
    focus: function focus(index) {
      console.debug('value-array focus', index);
      this.focusIndex = index;
    },
    input: function input(index, val) {
      this.$set(this.value, index, val);
    },
    remove: function remove(index) {
      var input = this.value.slice();
      input.splice(index, 1);
      this.$emit('input', input);
    },
    push: function push() {
      var a = this.value;
      var b = !a || !a[a.length - 1] ? {} : Object(__WEBPACK_IMPORTED_MODULE_0__libs_util_js__["d" /* inert */])(a[a.length - 1]);
      if (Object(__WEBPACK_IMPORTED_MODULE_0__libs_util_js__["h" /* toType */])(b) === 'ValueReference' && this.$root.fragments[b['@id']]) {
        b = Object(__WEBPACK_IMPORTED_MODULE_0__libs_util_js__["d" /* inert */])(this.$root.fragments[b['@id']]);
      }
      b['@id'] = '_:' + Date.now() % 1000000;
      b['@type'] = b['@type'] || 'schema:Thing';
      this.value.push(b);
    },

    toType: __WEBPACK_IMPORTED_MODULE_0__libs_util_js__["h" /* toType */]
  },
  components: {
    ValueArray: __WEBPACK_IMPORTED_MODULE_1__ValueArray_vue__["a" /* default */],
    ValueLiteral: __WEBPACK_IMPORTED_MODULE_2__ValueLiteral_vue__["a" /* default */],
    ValueObject: __WEBPACK_IMPORTED_MODULE_3__ValueObject_vue__["a" /* default */],
    ValueReference: __WEBPACK_IMPORTED_MODULE_4__ValueReference_vue__["a" /* default */],
    ValueString: __WEBPACK_IMPORTED_MODULE_5__ValueString_vue__["a" /* default */],
    ValueText: __WEBPACK_IMPORTED_MODULE_6__ValueText_vue__["a" /* default */]
  }
});

/***/ }),
/* 61 */
/*!********************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/opt/build/repo/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ValueLiteral.vue ***!
  \********************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__InputType_vue__ = __webpack_require__(/*! ./InputType.vue */ 62);
//
//
//
//
//
//
//
//
//
//
//
//



var acceptedTypes = ['xsd:boolean', 'xsd:date', 'xsd:dateTime', 'xsd:decimal', 'xsd:integer', 'xsd:string'];

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'value-literal',
  props: ['value', 'id'],
  computed: {
    atValue: {
      get: function get() {
        return this.value['@value'] || '';
      },
      set: function set(val) {
        this.$set(this.value, '@value', val);
      }
    },
    atType: {
      get: function get() {
        return this.value['@type'] || '';
      },
      set: function set(val) {
        this.$set(this.value, '@type', val);
      }
    },
    placeholder: function placeholder() {
      var alt = '';
      if (this.value['@type'] === 'xsd:date') {
        alt = 'ww/ww/wwww';
      }
      return this.model || alt;
    },
    inputType: function inputType() {
      if (this.atType && !this.atType.includes(':')) {
        this.atType = 'xsd:' + this.atType;
      }
      switch (this.atType) {
        case 'xsd:boolean':
          return 'checkbox';
        case 'xsd:date':
          return 'date';
        case 'xsd:dateTime':
          return 'text';
        case 'xsd:decimal':
          return 'number';
        case 'xsd:integer':
          return 'number';
        case 'xsd:string':
          return 'text';
      }
    }
  },
  methods: {
    blur: function blur() {
      console.debug('value-literal blur');
      if (!acceptedTypes.includes(this.atType)) {
        console.log('to ValueObject');
        this.$set(this.value, 'schema:name', this.model);
        this.$delete(this.value, '@value');
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.atType === '') {
      this.$nextTick(function () {
        return _this.$el.querySelector('.inp-type input').focus();
      });
    }
  },

  components: {
    InputType: __WEBPACK_IMPORTED_MODULE_0__InputType_vue__["a" /* default */]
  }
});

/***/ }),
/* 62 */
/*!**************************************!*\
  !*** ./src/components/InputType.vue ***!
  \**************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_opt_build_repo_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_InputType_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/opt/build/repo/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./InputType.vue */ 63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ed58516_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_InputType_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-2ed58516","hasScoped":false}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./InputType.vue */ 64);
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_opt_build_repo_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_InputType_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ed58516_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_InputType_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 63 */
/*!*****************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/opt/build/repo/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/InputType.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fuse_js__ = __webpack_require__(/*! fuse.js */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fuse_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fuse_js__);
//
//
//
//
//
//
//
//
//
//



var Classes = [{ i: 'xsd:boolean' }, { i: 'xsd:date' }, { i: 'xsd:dateTime' }, { i: 'xsd:decimal' }, { i: 'xsd:integer' }, { i: 'xsd:string' }];

var fuseOptions = {
  caseSensitive: false,
  includeScore: true,
  shouldSort: true,
  tokenize: false,
  threshold: 0.6,
  location: 0,
  distance: 100,
  id: 'i',
  keys: ['i']
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'input-type',
  props: ['value', 'placeholder'],
  data: function data() {
    return {
      term: null,
      options: null,
      ghost: 0
    };
  },

  computed: {
    index: function index() {
      var fragments = Classes;
      return new __WEBPACK_IMPORTED_MODULE_0_fuse_js___default.a(fragments, fuseOptions);
    }
  },
  methods: {
    blur: function blur() {
      var self = this;
      setTimeout(function () {
        self.term = null;
        self.options = null;
        self.ghost = 0;
        self.$emit('blur');
      }, 100);
    },
    input: function input() {
      if (!this.term) {
        this.options = [{
          action: 'Object',
          score: ''
        }];
        this.ghost = 0;
        return console.debug('No term');
      }
      this.options = this.index.search(this.term).slice(0, 20).concat({
        action: 'Object: ' + this.term,
        score: ''
      });
      this.ghost = Math.min(this.ghost, (this.options.length || 1) - 1);
    },
    keydown: function keydown(evt) {
      var key = evt.which || evt.keyCode;
      // key up&down
      if (key === 9) {
        this.confirm();
      } else if (key === 38) {
        this.ghost = Math.max(this.ghost - 1, 0);
      } else if (key === 40) {
        this.ghost = Math.min(this.ghost + 1, this.options.length - 1);
      }
    },
    submit: function submit(evt) {
      this.confirm();
      return false;
    },
    confirm: function confirm(uri) {
      console.debug('input-type confirm', uri);
      if (typeof uri === 'string') {
        this.$emit('input', uri);
        this.blur();
      } else if (!uri && this.options) {
        // TODO: set smart default @type
        this.$emit('input', this.options[this.ghost].item || this.term || 'schema:Person');
        this.blur();
      } else {
        console.debug('confirming but dont know what', uri);
      }
    }
  }
});

/***/ }),
/* 64 */
/*!*************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ed58516","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/InputType.vue ***!
  \*************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "inp-subtle inp-type fragment-type",
    class: {
      'inp-type-active': _vm.options
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.submit($event)
      },
      "keydown": _vm.keydown
    }
  }, [_c('span', {
    staticClass: "inp-subtle-span",
    domProps: {
      "textContent": _vm._s(_vm.term || _vm.value || _vm.placeholder)
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.term),
      expression: "term"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.value || _vm.placeholder
    },
    domProps: {
      "value": (_vm.term)
    },
    on: {
      "blur": _vm.blur,
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.term = $event.target.value
      }, _vm.input],
      "focus": _vm.input
    }
  }), _vm._v(" "), (_vm.options) ? _c('div', {
    staticClass: "ref-select"
  }, _vm._l((_vm.options), function(opt, index) {
    return _c('div', {
      key: opt.item,
      staticClass: "ref-option",
      class: {
        'ref-ghost': index === _vm.ghost
      },
      domProps: {
        "textContent": _vm._s(opt.item || opt.action)
      },
      on: {
        "mouseenter": function($event) {
          _vm.ghost = index
        },
        "mousedown": function($event) {
          _vm.confirm(opt.item)
        }
      }
    })
  })) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 65 */
/*!****************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26afdc3d","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ValueLiteral.vue ***!
  \****************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inp-subtle"
  }, [_c('span', {
    staticClass: "inp-subtle-span",
    domProps: {
      "textContent": _vm._s(_vm.placeholder + '.')
    }
  }), _vm._v(" "), (_vm.inputType == 'text') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.atValue),
      expression: "atValue"
    }],
    attrs: {
      "id": _vm.id,
      "type": "text"
    },
    domProps: {
      "value": (_vm.atValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.atValue = $event.target.value
      }
    }
  }) : (_vm.inputType == 'date') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.atValue),
      expression: "atValue"
    }],
    attrs: {
      "id": _vm.id,
      "type": "date"
    },
    domProps: {
      "value": (_vm.atValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.atValue = $event.target.value
      }
    }
  }) : (_vm.inputType == 'number') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.atValue),
      expression: "atValue"
    }],
    attrs: {
      "id": _vm.id,
      "type": "number"
    },
    domProps: {
      "value": (_vm.atValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.atValue = $event.target.value
      }
    }
  }) : (_vm.inputType == 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.atValue),
      expression: "atValue"
    }],
    attrs: {
      "id": _vm.id,
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.atValue) ? _vm._i(_vm.atValue, null) > -1 : (_vm.atValue)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.atValue,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.atValue = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.atValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.atValue = $$c
        }
      }
    }
  }) : _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.atValue),
      expression: "atValue"
    }],
    staticClass: "inp-big-focus",
    attrs: {
      "id": _vm.id
    },
    domProps: {
      "value": (_vm.atValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.atValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input-type', {
    attrs: {
      "placeholder": "wut"
    },
    on: {
      "blur": _vm.blur
    },
    model: {
      value: (_vm.atType),
      callback: function($$v) {
        _vm.atType = $$v
      },
      expression: "atType"
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 66 */
/*!**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-dffa81be","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ValueObject.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 67 */
/*!*******************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/opt/build/repo/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ValueObject.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_util_js__ = __webpack_require__(/*! ../libs/util.js */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__InputClass_vue__ = __webpack_require__(/*! ./InputClass.vue */ 7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InputReference_vue__ = __webpack_require__(/*! ./InputReference.vue */ 68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InputSubtle_vue__ = __webpack_require__(/*! ./InputSubtle.vue */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PropsList_vue__ = __webpack_require__(/*! ./PropsList.vue */ 11);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'value-object',
  props: ['value', 'id', 'focus'],
  data: function data() {
    return {
      expanded: false,
      search: false
    };
  },

  computed: {
    model: {
      get: function get() {
        return this.value || console.debug('falsy value object') || {};
      },
      set: function set(val) {
        this.$emit('input', val);
      }
    },
    isReference: function isReference() {
      return this.model['@id'] || this.search;
    },
    niceType: function niceType() {
      var t = this.model['@type'];
      return t ? t.slice(t.lastIndexOf(':') + 1) : '?';
    },
    label: function label() {
      var model = this.model;
      return !model['rdfs:label'] ? false : typeof model['rdfs:label'] === 'string' ? model['rdfs:label'] : Array.isArray(model['rdfs:label']) ? model['rdfs:label'][0]['@value'] : model['rdfs:label']['@value'];
    },
    placeholder: function placeholder() {
      return this.label || this.model['schema:name'] || this.model['@id'] || this.model['@value'] || 'Unnamed';
    },
    name: function name() {
      return this.model['dcterms:title'] || this.model['schema:name'];
    }
  },
  methods: {
    objectFocus: function objectFocus() {
      if (this.isReference) {
        console.debug('objectFocus');
        this.expanded = !this.expanded;
      }
    },
    toggleRef: function toggleRef(evt) {
      if (this.focus) {
        return console.warn('toggle: should not be focused');
      }
      // evt.stopPropagation()
      if (this.isReference) {
        console.debug('toggle ref=>object');
        this.model = Object.assign({}, this.model, {
          '@id': null,
          '@fromid': this.model['@id']
        });
        window.hub.$emit('arrayFocused');
      } else if (!this.search) {
        console.debug('toggle object=>ref');
        evt.stopPropagation();
        if (this.model['@id']) {
          this.model = { '@id': this.model['@id'] };
        } else if (this.model['@fromid']) {
          this.model = { '@id': this.model['@fromid'] };
        } else {
          this.search = true;
          this.$nextTick(function () {
            this.$el.querySelector('input').focus();
          });
        }
      } else {
        this.search = false;
      }
    },
    clear: function clear() {
      this.$emit('remove');
      if (!Array.isArray(this.$parent.renderType)) {
        this.model = this.model['schema:name'] || this.model.name || ' ';
      }
    }
  },
  components: {
    InputClass: __WEBPACK_IMPORTED_MODULE_1__InputClass_vue__["a" /* default */],
    InputReference: __WEBPACK_IMPORTED_MODULE_2__InputReference_vue__["a" /* default */],
    InputSubtle: __WEBPACK_IMPORTED_MODULE_3__InputSubtle_vue__["a" /* default */],
    PropsList: __WEBPACK_IMPORTED_MODULE_4__PropsList_vue__["a" /* default */]
  }
});

/***/ }),
/* 68 */
/*!*******************************************!*\
  !*** ./src/components/InputReference.vue ***!
  \*******************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_opt_build_repo_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_InputReference_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/opt/build/repo/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./InputReference.vue */ 69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fb7ccc0_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_InputReference_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-5fb7ccc0","hasScoped":false}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./InputReference.vue */ 70);
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_opt_build_repo_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_InputReference_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fb7ccc0_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_InputReference_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 69 */
/*!**********************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/opt/build/repo/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/InputReference.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fuse_js__ = __webpack_require__(/*! fuse.js */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fuse_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fuse_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// .ref-option: transition=staggered


var fuseOptions = {
  caseSensitive: false,
  includeScore: true,
  shouldSort: true,
  tokenize: false,
  threshold: 0.6,
  location: 0,
  distance: 100,
  id: '@id',
  keys: ['@id', 'schema:name', 'rdfs:label', 'dcterms:title', '@type', 'schema:description', 'schema:url']
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'input-reference',
  props: ['value', 'placeholder'],
  data: function data() {
    return {
      term: null,
      options: null,
      ghost: 0
    };
  },

  computed: {
    index: function index() {
      var _this = this;

      var fragments = Object.keys(this.$root.fragments).map(function (k) {
        return _this.$root.fragments[k];
      }).filter(Boolean);
      return new __WEBPACK_IMPORTED_MODULE_0_fuse_js___default.a(fragments, fuseOptions);
    }
  },
  methods: {
    blur: function blur() {
      var self = this;
      setTimeout(function () {
        self.term = null;
        self.options = null;
        self.ghost = 0;
      }, 100);
    },
    input: function input() {
      var needle = this.term;
      if (!needle) {
        this.options = null;
        this.ghost = 0;
        return;
      }
      this.options = this.index.search(needle).slice(0, 20);
      console.log(this.index, this.options);
      this.ghost = Math.min(this.ghost, (this.options.length || 1) - 1);
    },
    keydown: function keydown(evt) {
      var key = evt.which || evt.keyCode;
      // key up&down
      if (key === 9) {
        this.confirm();
      } else if (key === 38) {
        this.ghost = Math.max(this.ghost - 1, 0);
      } else if (key === 40) {
        this.ghost = Math.min(this.ghost + 1, this.options.length - 1);
      }
    },
    submit: function submit(evt) {
      this.confirm();
      return false;
    },
    confirm: function confirm(uri) {
      console.debug('input-ref confirm', uri);
      if (typeof uri === 'string') {
        this.$emit('input', { '@id': uri });
        this.blur();
      } else if (!uri && this.options) {
        this.$emit('input', { '@id': this.options[this.ghost].item });
        this.blur();
      } else {
        console.debug('confirming but dont know what', uri);
      }
    }
  }
});

/***/ }),
/* 70 */
/*!******************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5fb7ccc0","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/InputReference.vue ***!
  \******************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "inp-subtle",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.submit($event)
      },
      "keydown": _vm.keydown
    }
  }, [_c('span', {
    staticClass: "inp-subtle-span",
    domProps: {
      "textContent": _vm._s(_vm.term || _vm.placeholder)
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.term),
      expression: "term"
    }],
    staticClass: "inp-big-focus",
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.term)
    },
    on: {
      "blur": _vm.blur,
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.term = $event.target.value
      }, _vm.input]
    }
  }), (_vm.options) ? _c('transition-group', {
    staticClass: "ref-select",
    attrs: {
      "name": "staggered",
      "tag": "div"
    }
  }, _vm._l((_vm.options), function(opt, index) {
    return _c('div', {
      key: opt.item,
      staticClass: "ref-option",
      class: {
        'ref-ghost': index === _vm.ghost
      },
      domProps: {
        "textContent": _vm._s(opt.item + ' ' + opt.score)
      },
      on: {
        "mouseenter": function($event) {
          _vm.ghost = index
        },
        "mousedown": function($event) {
          _vm.confirm(opt.item)
        }
      }
    })
  })) : _vm._e()], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 71 */
/*!********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-16dd787f","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/PropsList.vue ***!
  \********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 72 */
/*!*****************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/opt/build/repo/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PropsList.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PropAdd_vue__ = __webpack_require__(/*! ./PropAdd.vue */ 73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_stub_js__ = __webpack_require__(/*! ../libs/stub.js */ 76);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'props-list',
  props: {
    fragment: {
      default: {
        'schema:name': 'fuckthis'
      }
    }
  },
  data: function data() {
    return {
      childFocused: false,
      suggest: null
    };
  },

  computed: {
    backdropClasses: function backdropClasses() {
      return {
        'backdrop--active': this.$root.listFocus.length > this.level,
        'backdrop--fixed': this.level === 1
      };
    },
    level: function level() {
      var vm = this.$parent;
      while (vm && typeof vm.level !== 'number') {
        vm = vm.$parent;
      }
      return vm ? vm.level + 1 : 1;
    }
  },
  methods: {
    listFocus: function listFocus(prop) {
      console.debug('listFocus', this.level, this.$root.listFocus);
      var listFocus = this.$root.listFocus;
      if (listFocus[this.level]) {
        this.$set(listFocus, this.level, prop);
      } else if (listFocus.length === this.level) {
        listFocus.push(prop);
      }
      this.$root.listFocus[this.level] = prop;
    },
    listBlur: function listBlur() {
      console.debug('listBlur', this.level);
      this.$root.listFocus = this.$root.listFocus.slice(0, this.level);
    }
  },
  mounted: function mounted() {
    var _this = this;

    Object(__WEBPACK_IMPORTED_MODULE_1__libs_stub_js__["a" /* toStub */])(this.fragment).forEach(function (key) {
      _this.$set(_this.fragment, key, null);
    });
  },

  components: {
    PropAdd: __WEBPACK_IMPORTED_MODULE_0__PropAdd_vue__["a" /* default */]
  }
});

/***/ }),
/* 73 */
/*!************************************!*\
  !*** ./src/components/PropAdd.vue ***!
  \************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_opt_build_repo_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_PropAdd_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/opt/build/repo/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./PropAdd.vue */ 74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_655412cf_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_PropAdd_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-655412cf","hasScoped":false}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./PropAdd.vue */ 75);
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_opt_build_repo_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_PropAdd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_655412cf_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_PropAdd_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 74 */
/*!***************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/opt/build/repo/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PropAdd.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__InputSubtle_vue__ = __webpack_require__(/*! ./InputSubtle.vue */ 4);
//
//
//
//
//
//
//
//
//



var DEFAULT_NAMESPACE = 'schema:';

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'prop-add',
  props: ['fragment'],
  data: function data() {
    return {
      prop: '',
      value: ''
    };
  },

  computed: {
    props: function props() {
      return this.fragment;
    },
    special: function special() {
      if (!this.prop) {
        return;
      }
      if (this.prop[0] === '@') {
        return { 'inp-alert': true };
      }
      if (this.prop.indexOf(':') === -1) {
        return { 'inp-urify': true };
      }
      return this.fragment;
    }
  },
  methods: {
    start: function start() {
      this.$nextTick(function () {
        this.$el.querySelector('input').focus();
      });
    },
    submit: function submit() {
      if (!this.prop.length) {
        if (this.$el.querySelector('.inp--label-prop>input') === document.activeElement) {
          this.$el.querySelector('input').focus();
        }
        return;
      }
      if (this.prop.indexOf(':') === -1 && this.prop[0] !== '@') {
        this.prop = DEFAULT_NAMESPACE + this.prop;
      }
      if (!this.value.length) {
        if (this.$el.querySelector('input') === document.activeElement) {
          this.$el.querySelector('.inp--label-prop>input').focus();
        }
        return;
      }
      this.$set(this.fragment, this.prop, this.value);
      this.prop = '';
      this.value = '';
      this.$el.querySelector('input').focus();
      // Lookup
    }
  },
  components: {
    InputSubtle: __WEBPACK_IMPORTED_MODULE_0__InputSubtle_vue__["a" /* default */]
  }
});

/***/ }),
/* 75 */
/*!***********************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-655412cf","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PropAdd.vue ***!
  \***********************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_c('label', {
    staticClass: "inp-text inp--label-prop",
    class: _vm.special
  }, [_c('input-subtle', {
    staticStyle: {
      "opacity": ".7"
    },
    attrs: {
      "placeholder": "property..."
    },
    on: {
      "blur": _vm.submit,
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.submit($event)
      }
    },
    model: {
      value: (_vm.prop),
      callback: function($$v) {
        _vm.prop = $$v
      },
      expression: "prop"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }],
    staticClass: "inp-big-focus",
    attrs: {
      "placeholder": _vm.prop && 'value...'
    },
    domProps: {
      "value": (_vm.value)
    },
    on: {
      "blur": _vm.submit,
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.submit($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.value = $event.target.value
      }
    }
  })], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 76 */
/*!**************************!*\
  !*** ./src/libs/stub.js ***!
  \**************************/
/*! exports provided: toStub */
/*! exports used: toStub */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toStub;
var TYPE = '@type';

function typeName(t) {
  return t && t.slice(t.lastIndexOf(':') + 1);
}

function suggest(type) {
  switch (type) {
    case 'Person':
      return ['schema:name', 'schema:address'];
    case 'LocalBusiness':
    case 'Organization':
      return ['schema:name', 'schema:vatID', 'schema:address', 'schema:founder'];
    case 'PostalAddress':
      return ['schema:name', 'schema:streetAddress', 'schema:addressLocality', 'schema:postalCode', 'schema:addressCountry'];
    case 'Invoice':
      return ['schema:name', 'schema:description', 'schema:dateCreated', 'schema:paymentDueDate', 'schema:paymentMethod', 'schema:provider', 'schema:customer', 'schema:referencesOrder'];
    case 'Offer':
      return ['schema:price'];
    case 'Order':
      return ['schema:orderedItem', 'schema:acceptedOffer'];
    case 'OrderItem':
      return ['schema:name'];
  }
  return ['schema:name', 'schema:description', 'schema:url'];
}

function toStub(fragment) {
  var type = fragment && fragment[TYPE] ? typeName(fragment[TYPE]) : 'Thing';
  var keys = Object.keys(fragment);

  return suggest(type).filter(function (key) {
    return keys.indexOf(key) === -1;
  });
}

/***/ }),
/* 77 */
/*!*************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16dd787f","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PropsList.vue ***!
  \*************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "props-list"
  }, [_vm._l((_vm.fragment), function(_, prop) {
    return (_vm.$root.showURI || prop[0] !== '@') ? _c('prop', {
      key: prop,
      attrs: {
        "fragment": _vm.fragment,
        "prop": prop
      },
      on: {
        "focus": function($event) {
          _vm.listFocus(prop)
        }
      }
    }) : _vm._e()
  }), _vm._v(" "), _c('prop-add', {
    attrs: {
      "fragment": _vm.fragment
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "backdrop",
    class: _vm.backdropClasses,
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.listBlur($event)
      }
    }
  })], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 78 */
/*!***************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dffa81be","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ValueObject.vue ***!
  \***************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "value-object",
    class: {
      'focus-object': _vm.focus
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.objectFocus($event)
      }
    }
  }, [_c('a', {
    staticClass: "inp-type-icon",
    attrs: {
      "href": "#"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.isReference ? '&rarr;' : '&bullet;')
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleRef($event)
      }
    }
  }), _vm._v(" "), (_vm.focus || _vm.search) ? _c('span', [(_vm.isReference) ? _c('input-reference', {
    attrs: {
      "placeholder": _vm.placeholder
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
      }
    },
    model: {
      value: (_vm.model),
      callback: function($$v) {
        _vm.model = $$v
      },
      expression: "model"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isReference && _vm.value['@value']) ? _c('input-subtle', {
    attrs: {
      "placeholder": "Just a value"
    },
    model: {
      value: (_vm.model['@value']),
      callback: function($$v) {
        _vm.$set(_vm.model, '@value', $$v)
      },
      expression: "model['@value']"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isReference && !_vm.value['@value']) ? _c('input-subtle', {
    attrs: {
      "placeholder": "Unnamed"
    },
    model: {
      value: (_vm.model['schema:name']),
      callback: function($$v) {
        _vm.$set(_vm.model, 'schema:name', $$v)
      },
      expression: "model['schema:name']"
    }
  }) : _vm._e()], 1) : _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.placeholder)
    }
  }), _vm._v(" "), _c('input-class', {
    attrs: {
      "placeholder": "wut"
    },
    model: {
      value: (_vm.model['@type']),
      callback: function($$v) {
        _vm.$set(_vm.model, '@type', $$v)
      },
      expression: "model['@type']"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-clear",
    on: {
      "click": _vm.clear
    }
  }, [_vm._v("×")]), _vm._v(" "), (_vm.expanded || !_vm.isReference) ? _c('props-list', {
    attrs: {
      "fragment": _vm.value
    }
  }) : _vm._e()], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 79 */
/*!*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1eb3f14e","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ValueReference.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 80 */
/*!**********************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/opt/build/repo/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ValueReference.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ValueObject_vue__ = __webpack_require__(/*! ./ValueObject.vue */ 5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_util_js__ = __webpack_require__(/*! ../libs/util.js */ 1);
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'value-reference',
  props: ['value', 'id', 'focus'],
  computed: {
    model: {
      get: function get() {
        var uri = Object(__WEBPACK_IMPORTED_MODULE_1__libs_util_js__["g" /* toMin */])((this.value || {})['@id']);
        var val = this.$root.fragments[uri] || this.$root.fetch(uri) || {};
        return val;
      },
      set: function set(val) {
        if (this.value && this.value['@temp']) {
          console.error('ref: setting a @temp fragment is a bad idea');
        }
        this.$emit('input', val);
      }
    }
  },
  components: {
    ValueObject: __WEBPACK_IMPORTED_MODULE_0__ValueObject_vue__["a" /* default */]
  }
});

/***/ }),
/* 81 */
/*!******************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1eb3f14e","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ValueReference.vue ***!
  \******************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "value-reference"
  }, [_c('value-object', {
    attrs: {
      "reference": 1,
      "focus": _vm.focus
    },
    on: {
      "changeRef": function($event) {},
      "focus": function($event) {
        _vm.$emit('focus')
      }
    },
    model: {
      value: (_vm.model),
      callback: function($$v) {
        _vm.model = $$v
      },
      expression: "model"
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 82 */
/*!*******************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/opt/build/repo/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ValueString.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'value-string',
  props: ['value', 'placeholder', 'id']
});

/***/ }),
/* 83 */
/*!***************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1aae7a1a","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ValueString.vue ***!
  \***************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    attrs: {
      "placeholder": "placeholder || 'needs placeholder'",
      "id": _vm.id
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        _vm.$emit('input', $event.target.value)
      }
    }
  })
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 84 */
/*!*****************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/opt/build/repo/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ValueText.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'value-text',
  props: ['value', 'id'],
  data: function data() {
    return {
      show: false
    };
  },

  computed: {
    model: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        this.$emit('input', val);
      }
    }
  },
  methods: {
    convertToLiteral: function convertToLiteral() {
      this.$emit('input', {
        '@type': '',
        '@value': this.value || ''
      });
    }
  }
});

/***/ }),
/* 85 */
/*!*************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ebc136e2","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ValueText.vue ***!
  \*************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inp-subtle"
  }, [_c('span', {
    staticClass: "inp-subtle-span",
    domProps: {
      "textContent": _vm._s((_vm.value || '') + '.')
    }
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model),
      expression: "model"
    }],
    staticClass: "inp-big-focus",
    attrs: {
      "id": _vm.id
    },
    domProps: {
      "value": (_vm.model)
    },
    on: {
      "focus": function($event) {
        _vm.show = 1
      },
      "blur": function($event) {
        _vm.show = 0
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model = $event.target.value
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "opacity"
    }
  }, [(_vm.show) ? _c('span', {
    staticClass: "inp-actions"
  }, [_c('button', {
    staticClass: "btn-reset fragment-type",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.convertToLiteral
    }
  }, [_vm._v("+")])]) : _vm._e()])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 86 */
/*!**************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b5522332","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ValueArray.vue ***!
  \**************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "value-array",
    class: {
      'value-array--focus': _vm.focusIndex >= 0
    }
  }, [_vm._l((_vm.value), function(item, index) {
    return _c(_vm.toType(item), {
      key: _vm.key(item) || index,
      tag: "component",
      attrs: {
        "value": item
      },
      on: {
        "focus": function($event) {
          _vm.focus(index)
        },
        "input": function($event) {
          _vm.input(index, $event)
        },
        "remove": function($event) {
          _vm.remove(index)
        }
      }
    })
  }), _vm._v(" "), _c('button', {
    staticClass: "btn-add",
    on: {
      "click": _vm.push
    }
  }, [_vm._v("Add")])], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 87 */
/*!********************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fe3f3bc","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Prop.vue ***!
  \********************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inp-text prop",
    class: _vm.propClasses,
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('label', {
    staticClass: "inp-label",
    attrs: {
      "for": _vm._uid,
      "title": _vm.prop
    }
  }, [_vm._v(_vm._s(_vm.niceProp))]), _vm._v(" "), _c(_vm.renderType, {
    tag: "component",
    attrs: {
      "id": _vm._uid,
      "focus": _vm.hasPropFocus,
      "value": _vm.fragment[_vm.prop]
    },
    on: {
      "focus": _vm.propFocus,
      "input": function($event) {
        _vm.$set(_vm.fragment, _vm.prop, $event)
      }
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 88 */
/*!*******************************************!*\
  !*** ./src/components/TextareaSubtle.vue ***!
  \*******************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_opt_build_repo_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_TextareaSubtle_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/opt/build/repo/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./TextareaSubtle.vue */ 89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f5092f4_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_TextareaSubtle_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-2f5092f4","hasScoped":false}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./TextareaSubtle.vue */ 90);
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_opt_build_repo_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_TextareaSubtle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f5092f4_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_TextareaSubtle_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 89 */
/*!**********************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/opt/build/repo/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/TextareaSubtle.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'textarea-subtle',
  props: ['value', 'placeholder'],
  computed: {
    model: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        this.$emit('input', val);
      }
    }
  }
});

/***/ }),
/* 90 */
/*!******************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f5092f4","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TextareaSubtle.vue ***!
  \******************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "inp-subtle"
  }, [_c('span', {
    staticClass: "inp-subtle-span",
    domProps: {
      "textContent": _vm._s((_vm.value || _vm.placeholder) + '.')
    }
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model),
      expression: "model"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.model)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model = $event.target.value
      }
    }
  })])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 91 */
/*!************************************!*\
  !*** ./src/mixins/PluginSystem.js ***!
  \************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      capabilities: [],
      plugins: {
        list: ['Invoice'],
        fetched: [],
        loaded: []
      }
    };
  },

  methods: {
    loadPlugin: function loadPlugin(name) {
      if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
        name = name['@type'];
      }
      if (!name) {
        return;
      }
      if (name.startsWith('schema:')) {
        name = name.slice(7);
      }
      if (!this.plugins.list.includes(name)) {
        return;
      }

      if (!this.$options.components[name]) {
        this.$options.components[name] = function () {
          return __webpack_require__(/*! ../plugins */ 92)("./" + name + '.vue');
        };
      }

      return name;
    },
    addCapability: function addCapability(capability) {
      if (this.capabilities.find(function (c) {
        return c.id === capability.id;
      })) {
        return;
      }
      this.capabilities.push(capability);
    }
  }
});

/***/ }),
/* 92 */
/*!****************************************!*\
  !*** ./src/plugins lazy ^\.\/.*\.vue$ ***!
  \****************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./Invoice.vue": [
		125,
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 92;
module.exports = webpackAsyncContext;

/***/ }),
/* 93 */
/*!*******************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/opt/build/repo/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/InputSingle.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_util_js__ = __webpack_require__(/*! ../libs/util.js */ 1);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'input-single',
  props: {
    a: null,
    path: null,
    label: null,
    length: {
      default: 10
    }
  },
  data: function data() {
    return {
      focus: false
    };
  },

  computed: {
    classes: function classes() {
      return {
        'input--empty': !this.model,
        'input--focus': this.focus
      };
    },

    model: {
      get: function get() {
        return this.parent[this.prop];
      },
      set: function set(v) {
        this.$set(this.parent, this.prop, v);
      }
    },
    parent: function parent() {
      return this.resolved.parent;
    },
    prop: function prop() {
      return this.resolved.prop;
    },
    resolved: function resolved() {
      if (!this.a || !this.a['@id']) {
        return console.warn('input single only supports fragments with @id');
      }

      var a = this.storage(this.a);

      var pieces = this.path && this.path.split('.') || [];
      var lastPiece = '.';

      // Loop over all path pieces
      for (var i = 0; i < pieces.length; i++) {
        var piece = 'schema:' + pieces[i];

        // Return the last piece and its parent
        if (i === pieces.length - 1) {
          if (typeof a[piece] === 'undefined') {
            this.$set(a, piece, '');
          }
          return {
            parent: a,
            prop: piece
          };
        }

        if (a[piece] === undefined) {
          this.$set(a, piece, { '@id': '', '@type': '', 'schema:name': '' });
          a = a[piece];
        } else if (!a[piece] || typeof a[piece] === 'string' || typeof a[piece] === 'number') {
          a[piece] = { '@id': '', '@type': '', 'schema:name': a[piece] || '' };
          a = a[piece];
        } else if (_typeof(a[piece]) === 'object') {
          a = this.storage(a[piece]) || a[piece];
        } else {
          console.warn('unexpected piece', a, piece);
        }

        lastPiece = piece;
      }
      throw 'path param in follow() is required';
    }
  },
  methods: {
    storage: function storage(key) {
      return this.$root.fragments[Object(__WEBPACK_IMPORTED_MODULE_0__libs_util_js__["g" /* toMin */])((typeof key === 'undefined' ? 'undefined' : _typeof(key)) === 'object' ? key['@id'] : key)];
    }
  }
});

/***/ }),
/* 94 */
/*!***************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b1b427a","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/InputSingle.vue ***!
  \***************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "input input--single",
    class: _vm.classes
  }, [_c('div', {
    staticClass: "input__label"
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('span', {
    staticClass: "input__input inp-subtle"
  }, [_c('span', {
    staticClass: "inp-subtle-span",
    domProps: {
      "textContent": _vm._s((_vm.model || '') + '.')
    }
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model),
      expression: "model"
    }],
    staticClass: "input__input__textarea",
    attrs: {
      "autofocus": !_vm.model,
      "type": "text"
    },
    domProps: {
      "value": (_vm.model)
    },
    on: {
      "focus": function($event) {
        _vm.focus = 1
      },
      "blur": function($event) {
        _vm.focus = 0
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model = $event.target.value
      }
    }
  })])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 95 */
/*!************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eb9449e2","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Fragment.vue ***!
  \************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fragment",
    class: {
      'focus-prop': _vm.focusProp, 'focus-from': _vm.focusFrom, 'fragment--advanced': _vm.advanced
    }
  }, [_c('header', [_c('h1', {
    staticClass: "fragment-h1"
  }, [_c('textarea-subtle', {
    attrs: {
      "placeholder": _vm.fragment['@id'] || 'Fatal error'
    },
    model: {
      value: (_vm.fragment['schema:name']),
      callback: function($$v) {
        _vm.$set(_vm.fragment, 'schema:name', $$v)
      },
      expression: "fragment['schema:name']"
    }
  }), _vm._v(" "), _c('input-class', {
    attrs: {
      "placeholder": "wut"
    },
    model: {
      value: (_vm.fragment['@type']),
      callback: function($$v) {
        _vm.$set(_vm.fragment, '@type', $$v)
      },
      expression: "fragment['@type']"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "fragment-json mdi mdi-12px mdi-code-braces",
    on: {
      "mouseenter": function($event) {
        _vm.advanced = 1
      },
      "mouseleave": function($event) {
        _vm.advanced = 0
      }
    }
  }, [_c('transition', {
    attrs: {
      "name": "opacity"
    }
  }, [(_vm.advanced) ? _c('div', [_c('form', {
    on: {
      "submit": _vm.copy
    }
  }, [_vm._v("\n            Copy fragment to:\n            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.copyURI),
      expression: "copyURI"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.copyURI)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.copyURI = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Copy")])]), _vm._v(" "), _c('form', {
    on: {
      "click": function($event) {
        _vm.$root.fetch(_vm.fragment['@id'], true)
      }
    }
  }, [_c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("refetch " + _vm._s(_vm.fragment['@id']))])]), _vm._v(" "), _c('pre', {
    staticClass: "fragment-pre"
  }, [_vm._v(_vm._s(_vm.fragment))]), _vm._v(" "), _c('input-raw', {
    model: {
      value: (_vm.fragment),
      callback: function($$v) {
        _vm.fragment = $$v
      },
      expression: "fragment"
    }
  })], 1) : _vm._e()])], 1)]), _vm._v(" "), _c('article', [(_vm.$root.show.json) ? _c('input-raw', {
    model: {
      value: (_vm.fragment),
      callback: function($$v) {
        _vm.fragment = $$v
      },
      expression: "fragment"
    }
  }) : _vm._e(), _vm._v(" "), _c('props-list', {
    attrs: {
      "fragment": _vm.fragment
    }
  })], 1), _vm._v(" "), _c('nav', {
    staticClass: "fragment__nav"
  }, [_c('div', {
    staticClass: "nav-right"
  }, [_c('button', {
    staticClass: "btn btn-soft app-nav__uri",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$root.showURI = !_vm.$root.showURI
      }
    }
  }, [_vm._v("URI")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-soft app-nav__uri",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$root.copyFragment(_vm.fragment['@id'])
      }
    }
  }, [_vm._v("Duplicate")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-soft app-nav__uri",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$root.show.json = !_vm.$root.show.json
      }
    }
  }, [_vm._v("JSON")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-soft app-nav__uri",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$root.sync(_vm.fragment['@id'])
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-soft app-nav__uri",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$root.discard(_vm.fragment['@id'])
      }
    }
  }, [_vm._v("Discard")]), _vm._v(" "), _vm._l((_vm.capabilities), function(c) {
    return _c('button', {
      staticClass: "btn btn-soft app-nav__uri",
      attrs: {
        "type": "button"
      },
      on: {
        "click": c.click
      }
    }, [_vm._v(_vm._s(c.label || c.type || '*'))])
  })], 2)]), _vm._v(" "), (_vm.loadPlugin(_vm.fragment) && _vm.resolved) ? _c(_vm.loadPlugin(_vm.fragment), {
    tag: "div",
    attrs: {
      "a": _vm.resolved,
      "options": _vm.options
    }
  }, [_vm._v("test")]) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 96 */
/*!********************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62c52549","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Edit.vue ***!
  \********************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-content",
    class: {
      'section-content--focus': _vm.$root.listFocus.length > 1
    }
  }, [(_vm.currentFragment) ? _c('fragment', {
    attrs: {
      "fragment": _vm.currentFragment
    }
  }) : _c('div', [_vm._v("\n    loading...\n  ")])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 97 */
/*!***********************************!*\
  !*** ./src/components/Create.vue ***!
  \***********************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_opt_build_repo_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/opt/build/repo/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./Create.vue */ 98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39f67d0a_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-39f67d0a","hasScoped":false}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./Create.vue */ 99);
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_opt_build_repo_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39f67d0a_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 98 */
/*!**************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/opt/build/repo/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Create.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      fragmentURI: null,
      fragmentName: null
    };
  },

  methods: {
    createByType: function createByType(type) {
      var id = '_:' + Math.random().toString(36).slice(2);
      this.$root.setFragment({
        '@type': 'schema:' + type,
        '@id': id,
        'schema:name': 'new ' + type,
        'schema:description': null,
        'schema:url': null
      });
      window.location.hash = '!' + id;
    }
  }
});

/***/ }),
/* 99 */
/*!**********************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39f67d0a","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Create.vue ***!
  \**********************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section-content"
  }, [_c('h1', [_vm._v("Create a new fragment")]), _vm._v(" "), _c('p', [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.createByType('Address')
      }
    }
  }, [_vm._v("Address")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.createByType('Invoice')
      }
    }
  }, [_vm._v("Invoice")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.createByType('LocalBusiness')
      }
    }
  }, [_vm._v("LocalBusiness")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.createByType('Person')
      }
    }
  }, [_vm._v("Person")])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 100 */
/*!**************************************!*\
  !*** ./src/components/ModalAuth.vue ***!
  \**************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_opt_build_repo_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_ModalAuth_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/opt/build/repo/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./ModalAuth.vue */ 101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7568b4c6_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ModalAuth_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-7568b4c6","hasScoped":false}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./ModalAuth.vue */ 102);
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_opt_build_repo_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_ModalAuth_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7568b4c6_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ModalAuth_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 101 */
/*!*****************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/opt/build/repo/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ModalAuth.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// .modal: transition=modal
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'modal-auth',
  data: function data() {
    return {
      name: '',
      status: null
    };
  },

  methods: {
    input: function input() {
      this.status = null;
    },
    submit: function submit() {
      var self = this;
      this.$root.userFetch(this.name).then(function (user) {
        self.status = null;
        if (!user || !user.auth || !user['@id']) {
          return console.warn('weird, the profile is not complete');
        }
        self.$root.userLoad();
        window.location.href = '#!' + user['@id'];
      }).catch(function (error) {
        self.status = error.status;
      });
    },
    add: function add() {
      var self = this;
      this.$root.userAdd(this.name).then(function (response) {
        self.status = response.status;
        self.feedback = response.status >= 400 ? 'Failed to create user' : null;
        if (self.status < 400) {
          self.submit();
        }
      });
    },
    label: function label(fragment) {
      return !fragment['rdfs:label'] ? false : typeof fragment['rdfs:label'] === 'string' ? fragment['rdfs:label'] : Array.isArray(fragment['rdfs:label']) ? fragment['rdfs:label'][0]['@value'] : fragment['rdfs:label']['@value'];
    }
  },
  mounted: function mounted() {
    // console.log('recent', this.$route.path)
  }
});

/***/ }),
/* 102 */
/*!*************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7568b4c6","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ModalAuth.vue ***!
  \*************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal"
  }, [_c('div', {
    staticClass: "modal-body",
    class: {
      'modal-nudge': _vm.status
    }
  }, [_c('form', {
    staticClass: "auth",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_c('label', {
    staticClass: "inp-text inp-auth",
    class: {
      'inp-error': _vm.status
    },
    on: {
      "input": _vm.input
    }
  }, [_c('div', {
    staticClass: "inp-label"
  }, [_vm._v("Fill in your username:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "inp-big-focus",
    attrs: {
      "placeholder": ". . . . . . . . . ."
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-save",
    attrs: {
      "type": "submit",
      "disabled": !_vm.name
    }
  }, [_vm._v("start")]), _vm._v(" "), (_vm.status === 404) ? _c('div', {
    staticClass: "auth-feedback"
  }, [_vm._v("\n        Unknown user, do you want to "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.add($event)
      }
    }
  }, [_vm._v("add it")]), _vm._v("?\n      ")]) : _c('div', {
    staticClass: "auth-feedback",
    domProps: {
      "textContent": _vm._s(_vm.status ? 'An error occurred' : '')
    }
  })])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 103 */
/*!********************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-427a9fc7","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue ***!
  \********************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'app--left': _vm.$root.show.appLeft, 'app--wide': _vm.appWide
    }
  }, [_c('app-nav'), _vm._v(" "), _c('app-left'), _vm._v(" "), (!_vm.$root.user['@id']) ? _c('modal-auth') : _vm._e(), _vm._v(" "), _c(_vm.$root.route.view, {
    tag: "component",
    nativeOn: {
      "mouseenter": function($event) {
        _vm.$root.show.appLeft = 0
      }
    }
  }, [_c('section', {
    staticClass: "section-content"
  })]), _vm._v(" "), _c('app-sync', {
    nativeOn: {
      "mouseenter": function($event) {
        _vm.$root.show.appLeft = 0
      }
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 104 */
/*!***************************!*\
  !*** ./src/scss/app.scss ***!
  \***************************/
/*! dynamic exports provided */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 105 */
/*!********************************************!*\
  !*** ./src/components/RecentFragments.vue ***!
  \********************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_opt_build_repo_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_RecentFragments_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/opt/build/repo/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./RecentFragments.vue */ 106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3eeace99_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_RecentFragments_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-3eeace99","hasScoped":false}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./RecentFragments.vue */ 107);
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_opt_build_repo_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_RecentFragments_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3eeace99_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_RecentFragments_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 106 */
/*!***********************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/opt/build/repo/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/RecentFragments.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'recent-fragments',
  props: ['list'],
  data: function data() {
    return {
      search: ''
    };
  },

  computed: {
    filteredList: function filteredList() {
      var _this = this;

      return Object.keys(this.$root.fragments).filter(function (f) {
        return f.includes(_this.search);
      });
    },
    hydratedList: function hydratedList() {
      var _this2 = this;

      return this.filteredList.map(function (uri) {
        return _this2.fragments[uri];
      }).filter(Boolean);
    },
    sortedList: function sortedList() {
      return this.order(this.hydratedList);
    },
    limitedList: function limitedList() {
      return this.sortedList;
    },
    fragments: function fragments() {
      return this.$root.fragments;
    }
  },
  methods: {
    enter: function enter(uri) {
      clearTimeout(this.intentTimeout);
      this.intentTimeout = setTimeout(function () {
        window.location.hash = '!' + uri;
        this.intentUri = null;
      }, 2000);
      this.intentUri = uri;
    },
    leave: function leave() {
      clearTimeout(this.intentTimeout);
      this.intentUri = null;
    },
    label: function label(fragment) {
      return !fragment['rdfs:label'] ? false : typeof fragment['rdfs:label'] === 'string' ? fragment['rdfs:label'] : Array.isArray(fragment['rdfs:label']) ? fragment['rdfs:label'][0]['@value'] : fragment['rdfs:label']['@value'];
    },
    rellipsis: function rellipsis(uri) {
      return uri.length < 40 ? uri : '...' + uri.slice(-30);
    },
    order: function order(arr) {
      if (!arr) {
        return arr;
      }
      var key = '@updated_at';

      var copy = arr.slice();
      copy.sort(function (a, b) {
        return b[key] === a[key] ? 0 : (b[key] || '') > (a[key] || '') ? 1 : -1;
      });
      console.log(copy.map(function (c) {
        return c[key];
      }));
      return copy;
    }
  },
  mounted: function mounted() {
    // console.log('recent', this.$route.path)
  }
});

/***/ }),
/* 107 */
/*!*******************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3eeace99","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RecentFragments.vue ***!
  \*******************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    class: {
      'nav-muted': !_vm.search
    }
  }, [_c('div', {
    staticClass: "inp-text inp-search"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    attrs: {
      "type": "text",
      "placeholder": 'Search through ' + _vm.$root.fragmentCount + ' fragments...'
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "nav-fragments"
  }, [(!_vm.search || !_vm.list) ? _c('div', {
    staticClass: "a-recent"
  }, [_c('a', {
    staticClass: "a-fragment",
    attrs: {
      "href": '#!create'
    },
    on: {
      "mouseenter": _vm.leave,
      "mouseleave": _vm.leave
    }
  }, [_vm._v("\n        Add...\n        "), _c('small', [_vm._v("new fragment")])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.limitedList), function(fragment) {
    return (!fragment['@temp']) ? _c('div', {
      staticClass: "a-recent"
    }, [_c('a', {
      staticClass: "a-fragment",
      attrs: {
        "href": '#!' + fragment['@id']
      },
      on: {
        "mouseenter": function($event) {
          _vm.enter(fragment['@id'])
        },
        "mouseleave": _vm.leave
      }
    }, [_vm._v("\n        " + _vm._s(fragment['schema:name'] || _vm.label(fragment) || fragment['dcterms:title'] || fragment['@id']) + "\n        "), (fragment['schema:name'] || _vm.label(fragment) || fragment['dcterms:title']) ? _c('small', [_vm._v(_vm._s(_vm.rellipsis(fragment['@id'])))]) : _vm._e()])]) : _vm._e()
  })], 2)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 108 */
/*!******************************!*\
  !*** ./src/mixins/Router.js ***!
  \******************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_util_js__ = __webpack_require__(/*! ../libs/util.js */ 1);


var routes = ['home', 'create', 'conf'];
var internals = ['config'];

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    // Use homepage as default because it is lightweight
    var route = {
      base: window.location.pathname,
      uri: '',
      view: 'home'
    };

    // Detect installation directory
    if (window.location.pathname !== '/') {
      // Replace url to get the router to start properly
      if (window.location.hash.length) {
        console.log('replace base url', route.base);
        window.history.replaceState('wut', 'ld3', route.base + window.location.hash);
      } else if (window.location.pathname.length > route.base.length) {
        console.log('replace complete url', route.base);
        window.history.replaceState('wut', 'ld3', route.base + '#!' + window.location.href);
      }
    }

    return {
      route: route
    };
  },

  methods: {
    hashchange: function hashchange() {
      var hash = window.location.hash.slice(1);

      // Exclamation mark will be ignored
      if (hash[0] === '!') {
        hash = hash.slice(1);
      }

      if (internals.includes(hash)) {
        hash = '_:' + hash;
      }

      // Colon means we are dealing with a URI
      if (hash.includes(':')) {
        this.route.view = 'edit';
        this.route.uri = Object(__WEBPACK_IMPORTED_MODULE_0__libs_util_js__["g" /* toMin */])(hash);
        window.document.title = this.route.uri + ' - ld3';
        // Avoid forced layout
        this.$nextTick(function () {
          var elem = document.querySelector('.section-content');
          elem && elem.scrollIntoView(true);
        });
      } else if (routes.includes(hash)) {
        this.route.view = hash;
        window.document.title = hash + ' - ld3';
        console.debug('hashchange: view', hash);
      } else {
        this.route.view = 'home';
        window.document.title = 'Home - ld3';
        console.debug('hashchange: fallback to home');
      }
    }
  },
  mounted: function mounted() {
    window.addEventListener('hashchange', this.hashchange, false);
    this.route.uri = Object(__WEBPACK_IMPORTED_MODULE_0__libs_util_js__["b" /* fromMin */])(window.location.hash.substr(2));
    this.hashchange();
  }
});

/***/ }),
/* 109 */
/*!*****************************!*\
  !*** ./src/mixins/Store.js ***!
  \*****************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_util_js__ = __webpack_require__(/*! ../libs/util.js */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_local_storage__ = __webpack_require__(/*! local-storage */ 15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_local_storage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_local_storage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_throttle__ = __webpack_require__(/*! lodash/throttle */ 112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_throttle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_throttle__);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

// import throttle from '../libs/throttle.js'




function hideSchema(obj) {
  // Collapse @value
  if (typeof obj['@value'] !== 'undefined') {
    return obj['@value'];
  }
  // Hide in current object
  for (var prop in obj) {
    if (prop.startsWith('schema:')) {
      obj[prop.slice(7)] = obj[prop];
      delete obj[prop];
    }
  }
  // Hide nested props
  for (var _prop in obj) {
    if (_typeof(obj[_prop]) === 'object' && obj[_prop] && Object.keys(obj[_prop]).length > 1) {
      obj[_prop] = hideSchema(obj[_prop]);
    }
  }
  return obj;
}

var fetching = {};

var CREATED_AT = '@created_at';
var FETCHED_AT = '@fetched_at';
var UPDATED_AT = '@updated_at';

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var fragments = {};
    var fetchedFragments = {};
    /*
    const fragments = ls('fragments') || {}
    const fetchedFragments = ls('fetchedFragments') || {}
    */

    if (!fragments['_:config']) {
      console.warn('Initial config');
      fragments['_:config'] = {
        '@id': '_:config',
        '@type': 'Config',
        plugins: false,
        serviceWorker: false
      };
      fetchedFragments['_:config'] = Object(__WEBPACK_IMPORTED_MODULE_0__libs_util_js__["d" /* inert */])(fragments['_:config']);
    }

    return {
      // Project setup
      config: fragments['_:config'],

      // Data
      fragments: fragments,
      fetchedFragments: fetchedFragments,
      storedFragments: Object(__WEBPACK_IMPORTED_MODULE_0__libs_util_js__["d" /* inert */])(fragments),

      // UI state
      listFocus: ['uri'],
      showURI: false,
      show: {
        appLeft: false,
        json: false,
        view: false
      }

    };
  },

  computed: {
    currentFragment: function currentFragment() {
      var inCache = this.fragments && this.route && this.route.uri && this.fragments[this.route.uri];
      console.log(new Date().toJSON().slice(0, 16));
      if (inCache) {
        if (inCache[FETCHED_AT] && inCache[FETCHED_AT].startsWith(new Date().toJSON().slice(0, 16))) {
          console.log();
          this.fetch(this.route.uri);
        }
        return inCache;
      }

      // Prepare reactivity
      this.$set(this.fragments, this.route.uri, null);
      this.$set(this.fetchedFragments, this.route.uri, null);
      var notInCache = this.fragments[this.route.uri] || {};

      return this.fetch(this.route.uri);
    },
    fragmentCount: function fragmentCount() {
      return this.fragmentList.length;
    },
    fragmentList: function fragmentList() {
      return Object.keys(this.fragments);
    }
  },
  methods: {
    checkSave: function checkSave() {
      // this.syncAgo++
    },
    discard: function discard(uri) {
      if (typeof uri !== 'string') {
        return console.error('Store.discard expects string, but got', typeof uri === 'undefined' ? 'undefined' : _typeof(uri));
      }
      if (this.fetchedFragments[uri]) {
        this.fragments[uri] = Object(__WEBPACK_IMPORTED_MODULE_0__libs_util_js__["d" /* inert */])(this.fetchedFragments[uri]);
        this.syncLocal();
      } else {
        this.$set(this.fetchedFragments, uri, null);
        this.fragments[uri] = Object(__WEBPACK_IMPORTED_MODULE_0__libs_util_js__["d" /* inert */])(this.fetchedFragments[uri]);
        this.fetch(uri);
      }
    },
    sync: function sync(fragment) {
      var _this = this;

      if (typeof fragment === 'string') {
        fragment = Object(__WEBPACK_IMPORTED_MODULE_0__libs_util_js__["d" /* inert */])(this.fragments[Object(__WEBPACK_IMPORTED_MODULE_0__libs_util_js__["g" /* toMin */])(fragment)]);
      }
      if ((typeof fragment === 'undefined' ? 'undefined' : _typeof(fragment)) !== 'object' || fragment === null) {
        return console.error('Store.sync expects object, but got', typeof fragment === 'undefined' ? 'undefined' : _typeof(fragment));
      }

      // Save local fragments to localStorage
      var id = fragment['@id'];
      if (id && id.startsWith('_:')) {
        this.fetchedFragments[id] = Object(__WEBPACK_IMPORTED_MODULE_0__libs_util_js__["d" /* inert */])(fragment);
        this.syncLocal();
        return console.log('Store.sync only local');
      }

      //
      fragment = Object(__WEBPACK_IMPORTED_MODULE_0__libs_util_js__["b" /* fromMin */])(Object(__WEBPACK_IMPORTED_MODULE_0__libs_util_js__["d" /* inert */])(fragment));
      delete fragment['@temp'];
      delete fragment['@fake'];
      delete fragment[FETCHED_AT];

      // Update timestamps
      fragment[UPDATED_AT] = Object(__WEBPACK_IMPORTED_MODULE_0__libs_util_js__["f" /* timestamp */])();
      if (!fragment[CREATED_AT]) {
        fragment[CREATED_AT] = Object(__WEBPACK_IMPORTED_MODULE_0__libs_util_js__["f" /* timestamp */])();
      }

      Object(__WEBPACK_IMPORTED_MODULE_0__libs_util_js__["e" /* putJSON */])(fragment).then(function (body) {
        if (!body.success) {
          console.warn(body);
        } else {
          _this.fetch(id, true);
        }
      }).catch(function (body) {
        console.warn(body);
      });
    },
    fetch: function fetch(uri, force) {
      var _this2 = this;

      if (typeof uri !== 'string') {
        return console.error('Store.fetch expects string, but got', typeof uri === 'undefined' ? 'undefined' : _typeof(uri));
      }
      uri = Object(__WEBPACK_IMPORTED_MODULE_0__libs_util_js__["b" /* fromMin */])(uri);
      if (fetching[uri] && !force) {
        return console.log(' cancel', uri);
      }
      if (!uri.startsWith('http')) {
        console.log(this.fragments, uri, this.fragments[uri]);
        return console.log(' this aint no uri', uri) || this.fragments[uri];
      }
      if (uri.endsWith('anonymous')) {
        // Fetched is set to true, but might have to be flagged in another way
        return this.setFragment({ '@type': 'schema:Person', '@id': 'ld3:anonymous', 'schema:name': 'Anonymous person' }, true);
      }
      fetching[uri] = true;
      Object(__WEBPACK_IMPORTED_MODULE_0__libs_util_js__["c" /* getJSON */])(uri).then(function (data) {
        return _this2.addGraph(data, true);
      }).catch(function (body) {
        console.error('Store.fetch didnt retrieve', uri, body);
      });
      // this.$root.route.uri += '#temp'
      return {
        '@temp': true,
        '@id': uri,
        'schema:name': 'Temporary'
      };
    },
    addGraph: function addGraph(body, fetched) {
      if (!body) {
        return console.warn('no data in response');
      }
      if ((typeof body === 'undefined' ? 'undefined' : _typeof(body)) !== 'object') {
        return console.warn('no object in data of response');
      }
      if (body.length && body[0]) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = body[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var s = _step.value;

            if (s['@id']) {
              this.setFragment(s, fetched);
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      } else if (body['@id']) {
        this.setFragment(body, fetched);
      } else if (body['@graph']) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = body['@graph'][Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var _s = _step2.value;

            if (_s['@id']) {
              this.setFragment(_s, fetched);
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }
      this.syncLocal();
    },
    copyFragment: function copyFragment(uri, to) {
      if (!this.fragments[uri]) {
        return console.warn('Store.rename: cant find', uri);
      }
      if (!to) {
        var index = uri.lastIndexOf('/');
        to = index > 0 ? uri.slice(0, index + 1) : '_:';
        to += Math.random().toString(36).slice(2);
      } else if (this.fragments[to]) {
        return console.warn('Store.rename: overwriting is disabled', to);
      }
      var temp = Object(__WEBPACK_IMPORTED_MODULE_0__libs_util_js__["d" /* inert */])(this.fragments[uri]);
      temp['@id'] = to;
      this.setFragment(temp);
      console.log('copied', uri, 'to', to);
      window.location.href = '#!' + to;
      return to;
    },
    setFragment: function setFragment(f, fetched) {
      f = Object(__WEBPACK_IMPORTED_MODULE_0__libs_util_js__["g" /* toMin */])(f);
      if (f['@id'].endsWith(':')) {
        return;
      }
      this.$set(this.fragments, f['@id'], f);

      //
      if (fetched) {
        f[FETCHED_AT] = Object(__WEBPACK_IMPORTED_MODULE_0__libs_util_js__["f" /* timestamp */])();
        this.$set(this.fetchedFragments, f['@id'], Object(__WEBPACK_IMPORTED_MODULE_0__libs_util_js__["d" /* inert */])(f));
      } else if (!this.fetchedFragments.hasOwnProperty(f['@id'])) {
        this.$set(this.fetchedFragments, f['@id'], null);
      }
      // if (this.$root.route.uri.endsWith('#temp')) {
      //   this.$nextTick(() => this.$root.route.uri = this.$root.route.uri.slice(0, -5))
      // }
      return f;
    },
    resolve: function resolve(uri, options) {
      options = options || 0;
      if (!this.fragments) {
        return console.warn('No fragments in storage..');
      }
      if ((typeof uri === 'undefined' ? 'undefined' : _typeof(uri)) === 'object') {
        uri = uri['@id'];
      }
      if (!uri) {
        return; // console.warn('This uri is falsy', uri)
      }
      uri = Object(__WEBPACK_IMPORTED_MODULE_0__libs_util_js__["g" /* toMin */])(uri);
      if (!this.fragments[uri]) {
        this.fetch(uri);
        return; // console.warn(uri, 'was not found in storage')
      }
      var obj = Object(__WEBPACK_IMPORTED_MODULE_0__libs_util_js__["d" /* inert */])(this.fragments[uri]);
      for (var prop in obj) {
        // Recursive
        if (options > 0 && obj[prop] && _typeof(obj[prop]) === 'object' && Object.keys(obj[prop]).length === 1 && obj[prop]['@id']) {
          obj[prop] = this.resolve(obj[prop]['@id'], options - 1);
        }
      }
      obj = hideSchema(obj);
      return obj;
    },
    loadWorkspace: function loadWorkspace(list) {
      if (!list || !list.length) {
        return console.warn('No workspaces to load!');
      }
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = list[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var ns = _step3.value;

          if (ns['ld3:prefix'] || ns.prefix) {
            namespaces.push({
              prefix: (ns['ld3:prefix'] || ns.prefix) + ':',
              url: ns.url || ns['@id']
            });
          }
        }
        // Reverse sort to allow efficient dedup and correct namespace minification
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      namespaces.sort(function (a, b) {
        return b.url.localeCompare(a.url);
      });
      // Dedup
      for (var last, i = namespaces.length - 1; i >= 0; i--) {
        last = last === namespaces[i].url ? namespaces.splice(i, 1)[0].url : namespaces[i].url;
      }
      console.log(Object.keys(this.fragments).filter(function (k) {
        return k.startsWith('http');
      }));
    },

    syncLocal: __WEBPACK_IMPORTED_MODULE_2_lodash_throttle___default()(function () {
      this.actualSyncLocal();
    }, 2000),
    actualSyncLocal: function actualSyncLocal() {
      console.log('storeLocally', this);
      if (!this) return;

      // Keep a copy of what is stored 
      this.storedFragments = Object(__WEBPACK_IMPORTED_MODULE_0__libs_util_js__["d" /* inert */])(this.fragments);

      //
      __WEBPACK_IMPORTED_MODULE_1_local_storage___default()('fragments', this.fragments);
      __WEBPACK_IMPORTED_MODULE_1_local_storage___default()('fetchedFragments', this.fetchedFragments);
      console.log('succes');
    },
    clearCache: function clearCache() {
      this.fragments = {};
      __WEBPACK_IMPORTED_MODULE_1_local_storage___default.a.remove('fragments');
      __WEBPACK_IMPORTED_MODULE_1_local_storage___default.a.remove('fetchedFragments');
    },
    initStorage: function initStorage() {
      this.loadWorkspace(__WEBPACK_IMPORTED_MODULE_1_local_storage___default.a.get('namespaces') || STORE_NAMESPACES);
      var fragments = __WEBPACK_IMPORTED_MODULE_1_local_storage___default.a.get('fragments') || {};
      this.addGraph({ '@graph': Object.keys(fragments).map(function (k) {
          return fragments[k];
        }) });
    }
  }
});

/***/ }),
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */
/*!****************************!*\
  !*** ./src/mixins/User.js ***!
  \****************************/
/*! exports provided: LD3_PROFILES, LD3_PERSON, LD3_SERVER, LD3_USER, default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LD3_PROFILES */
/* unused harmony export LD3_PERSON */
/* unused harmony export LD3_SERVER */
/* unused harmony export LD3_USER */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_util_js__ = __webpack_require__(/*! ../libs/util.js */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_throttle_js__ = __webpack_require__(/*! ../libs/throttle.js */ 123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_local_storage__ = __webpack_require__(/*! local-storage */ 15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_local_storage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_local_storage__);




var LD3_PROFILES = 'https://id.thomasg.be/ld3-profiles/';

var LD3_PERSON = { '@type': 'schema:Person', '@id': 'ld3:anonymous', 'schema:name': 'Anonymous person' };
var LD3_SERVER = [{ '@id': 'https://id.thomasg.be/#server' }];

var LD3_USER = {
  '@type': 'ld3:Profile',
  '@id': 'ld3:no-user',
  'schema:name': '',
  person: LD3_PERSON,
  server: LD3_SERVER,
  ui: {
    tabs: []
  },
  workspace: [{
    'schema:name': 'LBLOD test data',
    'ld3:prefix': 'lblod',
    url: 'https://id.thomasg.be/lblod'
  }]
};

var user = __WEBPACK_IMPORTED_MODULE_2_local_storage___default()('user') || Object(__WEBPACK_IMPORTED_MODULE_0__libs_util_js__["d" /* inert */])(LD3_USER);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: {
    user: user
  },
  computed: {
    auth: function auth() {
      return this.user['@id'] && this.user['@id'] !== 'ld3:no-user';
    }
  },
  methods: {
    userFetch: function userFetch(uri) {
      if (!uri.startsWith('http')) {
        uri = LD3_PROFILES + uri;
      }
      var self = this;
      return Object(__WEBPACK_IMPORTED_MODULE_0__libs_util_js__["c" /* getJSON */])(uri).then(function (body) {
        self.setFragment(Object(__WEBPACK_IMPORTED_MODULE_0__libs_util_js__["d" /* inert */])(body), true);
        for (var key in body) {
          user[key] = body[key];
        }
        __WEBPACK_IMPORTED_MODULE_2_local_storage___default()('user', user);
        return user;
      }).catch(function (error) {
        if (error.status === 404) {
          user['@id'] = null;
          user.person = null;
          user.workspace = null;
          __WEBPACK_IMPORTED_MODULE_2_local_storage___default()('user', user);
        }
        throw error;
      });
    },
    userAdd: function userAdd(uri) {
      if (!uri.startsWith('http')) {
        uri = LD3_PROFILES + uri;
      }
      var data = Object(__WEBPACK_IMPORTED_MODULE_0__libs_util_js__["d" /* inert */])(LD3_USER);
      data['@id'] = uri;
      return Object(__WEBPACK_IMPORTED_MODULE_0__libs_util_js__["e" /* putJSON */])(data).then(function (body) {
        for (var key in body) {
          user[key] = body[key] || null;
        }
        body.status = 200;
        return body;
      }).catch(function (error) {
        if (error.status !== 404) {
          return error.response;
        }
        user['@id'] = null;
        user.person = null;
        user.workspace = null;
        return error.response;
      });
    },
    userLoad: function userLoad() {
      // this.$root.loadWorkspace(user.workspace)
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = user.workspace[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var w = _step.value;

          this.$root.fetch(w.url, true);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    userLogout: function userLogout() {
      __WEBPACK_IMPORTED_MODULE_2_local_storage___default.a.remove('user');
      var u = Object(__WEBPACK_IMPORTED_MODULE_0__libs_util_js__["d" /* inert */])(LD3_USER);
      u['@id'] = null;
      for (var key in u) {
        user[key] = u[key] || null;
      }
    }
  },
  mounted: function mounted() {
    if (!this.auth) {
      return;
    }
    this.userLoad();
    console.log('User.ready', user.workspace && user.workspace.length, Object(__WEBPACK_IMPORTED_MODULE_0__libs_util_js__["d" /* inert */])(user));
  },

  watch: {
    user: {
      deep: true,
      handler: Object(__WEBPACK_IMPORTED_MODULE_1__libs_throttle_js__["a" /* default */])(function () {
        console.debug('ls save user');
        __WEBPACK_IMPORTED_MODULE_2_local_storage___default()('user', user);
      })
    }
  }
});

/***/ }),
/* 123 */
/*!******************************!*\
  !*** ./src/libs/throttle.js ***!
  \******************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = throttle;
// https://remysharp.com/2010/07/21/throttling-function-calls
function throttle(fn, threshold, scope) {
  threshold || (threshold = 250);
  var last, deferTimer;
  return function () {
    var context = scope || this;
    var now = +new Date();
    var args = arguments;
    if (last && now < last + threshold) {
      // hold on to it
      clearTimeout(deferTimer);
      deferTimer = setTimeout(function () {
        last = now;
        fn.apply(context, args);
      }, threshold);
    } else {
      last = now;
      fn.apply(context, args);
    }
  };
}

/***/ }),
/* 124 */
/*!******************************!*\
  !*** ./src/mixins/Worker.js ***!
  \******************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  ready: function ready() {
    if (this.$root.config.serviceWorker) {
      if ('serviceWorker' in navigator) {
        window.addEventListener('load', function () {
          navigator.serviceWorker.register('/sw.js');
        });
      }
    }
  }
});

/***/ })
],[19]);


// WEBPACK FOOTER //
// client.b31b4ffa.js